/* tslint:disable */
/* eslint-disable */
/**
 * External Customer Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';


export const RHIMAPOCommonDataCustomerManagementContactType = {
    IngressSucessRecipient: 'IngressSucessRecipient',
    IngressFailureRecipient: 'IngressFailureRecipient',
    WearReportRecipient: 'WearReportRecipient',
    IngressMailSender: 'IngressMailSender',
    OperationsNotificationRecipient: 'OperationsNotificationRecipient',
    AlertRecipient: 'AlertRecipient',
} as const;

export type RHIMAPOCommonDataCustomerManagementContactType = typeof RHIMAPOCommonDataCustomerManagementContactType[keyof typeof RHIMAPOCommonDataCustomerManagementContactType];



export const RHIMAPOCoreWebRolesCustomerSpecificRole = {
    Operator: 'Operator',
    ProcessEngineer: 'ProcessEngineer',
    TechnicalMarketing: 'TechnicalMarketing',
    Onboarding: 'Onboarding',
    DataReader: 'DataReader',
    Contractor: 'Contractor',
} as const;

export type RHIMAPOCoreWebRolesCustomerSpecificRole = typeof RHIMAPOCoreWebRolesCustomerSpecificRole[keyof typeof RHIMAPOCoreWebRolesCustomerSpecificRole];



export const RHIMAPOCoreWebRolesGlobalRole = {
    Administrator: 'Administrator',
    Onboarding: 'Onboarding',
    MasterDataApiReader: 'MasterDataApiReader',
    ProductOwner: 'ProductOwner',
} as const;

export type RHIMAPOCoreWebRolesGlobalRole = typeof RHIMAPOCoreWebRolesGlobalRole[keyof typeof RHIMAPOCoreWebRolesGlobalRole];



export const RHIMAPOCustomerManagementWebServicesCrkVesselPropertiesCrkRunningMeterZeroLocation = {
    Outlet: 'Outlet',
    Inlet: 'Inlet',
} as const;

export type RHIMAPOCustomerManagementWebServicesCrkVesselPropertiesCrkRunningMeterZeroLocation = typeof RHIMAPOCustomerManagementWebServicesCrkVesselPropertiesCrkRunningMeterZeroLocation[keyof typeof RHIMAPOCustomerManagementWebServicesCrkVesselPropertiesCrkRunningMeterZeroLocation];


export interface RHIMAPOCustomerManagementWebV2ModelsAvailableVesselTemplateVesselTypesDto {
    'vesselTypes'?: Array<string> | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsContactPersonDto {
    /**
     * User\'s identifier.
     */
    'id': string;
    /**
     * User\'s first name.
     */
    'firstName'?: string | null;
    /**
     * User\'s last name.
     */
    'lastName'?: string | null;
    /**
     * User\'s job.
     */
    'job'?: string | null;
    /**
     * User\'s  email address.
     */
    'emailAddress'?: string | null;
    /**
     * User\'s phone.
     */
    'phone'?: string | null;
    /**
     * User\'s notes.
     */
    'notes'?: string | null;
    /**
     * User\'s contact types.
     */
    'contactTypes'?: Array<RHIMAPOCommonDataCustomerManagementContactType> | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsContactUsDto {
    'firstName': string;
    'lastName': string;
    'email': string;
    'company'?: string | null;
    'message': string;
    'subject': string;
}
/**
 * Describe which feature is to be assigned to a customer.
 */
export interface RHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto {
    /**
     * The feature to add.
     */
    'feature': RHIMContractsHmdFeature;
}


export interface RHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto {
    /**
     * If this value is provided the Id is forced to be this value.  If it is null or omitted the Guid is generated randomly
     */
    'id'?: string | null;
    /**
     * The short unique name of the customer
     */
    'shortName': string;
    /**
     * This is the full name of the customer (not the unique short name)
     */
    'displayName': string;
    /**
     * The industry the customer plant belongs to
     */
    'industry': string;
    /**
     * Customer\'s location. Usually it is location of the plant or country.  Based on customer location is calculated customer time zone.                When not provided [0,0] is used as a default value.
     */
    'location'?: RHIMHMDCustomerManagementContractsV2CustomerCustomerLocationDto | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto {
    'displayName'?: string | null;
    'customerAssignments'?: Array<string> | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsCustomerGroupDto {
    'id': string;
    'displayName'?: string | null;
    'customerAssignments'?: Array<string> | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsCustomerOverviewDto {
    /**
     * The id of the customer
     */
    'id': string;
    /**
     * The short unique name of the customer
     */
    'shortName'?: string | null;
    /**
     * This is the full name of the customer (not the unique short name)
     */
    'displayName'?: string | null;
    /**
     * The industry of the customer
     */
    'industry': string;
    /**
     * The customer location
     */
    'location'?: RHIMHMDCustomerManagementContractsV2CustomerCustomerLocationDto | null;
    /**
     * The IANA Timezone name of the customer - calculated from the RHIM.APO.CustomerManagement.Web.V2.Models.CustomerOverviewDto.Location property
     */
    'timeZoneName'?: string | null;
    /**
     * The fleets of the customer
     */
    'fleet'?: { [key: string]: number; } | null;
    /**
     * The amount of user which have a direct role assignment to this customer
     */
    'userCount': number;
}
/**
 * Describe which feature of is to be removed from a customer.
 */
export interface RHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto {
    /**
     * The feature to remove.
     */
    'feature': RHIMContractsHmdFeature;
}


export interface RHIMAPOCustomerManagementWebV2ModelsCustomerRoleAssignmentDto {
    /**
     * Id of the User
     */
    'userId': string;
    /**
     * Id of the customer
     */
    'customerId': string;
    /**
     * Assigned role of the user with id RHIM.APO.CustomerManagement.Web.V2.Models.CustomerRoleAssignmentDto.UserId on customer with id RHIM.APO.CustomerManagement.Web.V2.Models.CustomerRoleAssignmentDto.CustomerId
     */
    'customerRole': RHIMAPOCoreWebRolesCustomerSpecificRole;
}


export interface RHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto {
    /**
     * This is the full name of the customer (not the unique short name)
     */
    'displayName': string;
    /**
     * The industry the customer plant belongs to
     */
    'industry': string;
    /**
     * Customer\'s location. Usually it is location of the plant or country.  Based on customer location is calculated customer time zone.                When not provided [0,0] is used as a default value.
     */
    'location'?: RHIMHMDCustomerManagementContractsV2CustomerCustomerLocationDto | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsExternalReferencesDto {
    'customerPortalId'?: string | null;
    'crmNumber'?: string | null;
    'sap'?: string | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsFeatureAddDto {
    'name': string;
    'displayName'?: string | null;
    'description'?: string | null;
    'position': number;
    'isVisible': boolean;
    'options'?: string | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto {
    'name': string;
    'position': number;
    'isVisible': boolean;
}
export interface RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryMaintenanceDto {
    'id': string;
    'name': string;
    'position': number;
    'isVisible': boolean;
    'modifiedBy': string;
    'modifiedOnUtc': string;
    'features': Array<RHIMAPOCustomerManagementWebV2ModelsFeatureMaintenanceDto>;
}
export interface RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto {
    'name': string;
    'position': number;
    'isVisible': boolean;
}
export interface RHIMAPOCustomerManagementWebV2ModelsFeatureMaintenanceDto {
    'id': string;
    'name': string;
    'displayName'?: string | null;
    'description'?: string | null;
    'position': number;
    'isVisible': boolean;
    'featureType': RHIMContractsFeatureType;
    'options'?: string | null;
    'modifiedBy': string;
    'modifiedOnUtc': string;
}


export interface RHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto {
    'displayName'?: string | null;
    'description'?: string | null;
    'position': number;
    'isVisible': boolean;
    'options'?: string | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsItemPositionDto {
    'id': string;
    'position': number;
}
export interface RHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto {
    'items': Array<RHIMAPOCustomerManagementWebV2ModelsItemPositionDto>;
}
/**
 * APO roles.
 */
export interface RHIMAPOCustomerManagementWebV2ModelsRolesDto {
    /**
     * APO customer roles.
     */
    'customerRoles'?: Array<RHIMAPOCoreWebRolesCustomerSpecificRole> | null;
    /**
     * APO global roles.
     */
    'globalRoles'?: Array<RHIMAPOCoreWebRolesGlobalRole> | null;
}
/**
 * Describe which user\'s should be added as a contact person
 */
export interface RHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto {
    /**
     * User Id.
     */
    'userId': string;
    /**
     * User contact types.
     */
    'contactTypes': Array<RHIMAPOCommonDataCustomerManagementContactType>;
}
export interface RHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto {
    'customerPortalId'?: string | null;
    'crmNumber'?: string | null;
    'sap'?: string | null;
}
/**
 * User data to create a new user.
 */
export interface RHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto {
    /**
     * User\'s first name.  The field is required.
     */
    'firstName': string;
    /**
     * User\'s last name.  The field is required.
     */
    'lastName': string;
    /**
     * User\'s job.
     */
    'job'?: string | null;
    /**
     * User\'s  email address.  The field is required and must be unique.
     */
    'emailAddress': string;
    /**
     * User\'s phone.
     */
    'phone'?: string | null;
    /**
     * User\'s notes.
     */
    'notes'?: string | null;
    /**
     * Not active users are not allowed to login
     */
    'isActive': boolean;
}
/**
 * Current user\'s customer APO role.
 */
export interface RHIMAPOCustomerManagementWebV2ModelsUserCustomerGroupRoleDto {
    /**
     * Customer group id.
     */
    'customerGroupId': string;
    /**
     * Customer Group name.
     */
    'customerGroupDisplayName'?: string | null;
    /**
     * Customer role.
     */
    'customerGroupRoles'?: Array<RHIMAPOCoreWebRolesCustomerSpecificRole> | null;
}
/**
 * Current user\'s customer APO role.
 */
export interface RHIMAPOCustomerManagementWebV2ModelsUserCustomerRoleDto {
    /**
     * Customer id.
     */
    'customerId': string;
    /**
     * Customer name.
     */
    'customerDisplayName'?: string | null;
    /**
     * Customer role.
     */
    'customerRoles'?: Array<RHIMAPOCoreWebRolesCustomerSpecificRole> | null;
}
/**
 * User details.
 */
export interface RHIMAPOCustomerManagementWebV2ModelsUserDetailDto {
    /**
     * User roles.
     */
    'roles'?: RHIMAPOCustomerManagementWebV2ModelsUserRolesDto | null;
    /**
     * Latest date and time when user has accepted terms of use for apo portal.
     */
    'termsOfUseAcceptedAtUtc'?: string | null;
    'lastLoggedIn'?: string | null;
    'createdOn'?: string | null;
    'modifiedOnUtc'?: string | null;
    'modifiedBy'?: string | null;
    /**
     * User\'s active directory object identifier.
     */
    'aadObjectId'?: string | null;
    /**
     * User\'s identifier.
     */
    'id': string;
    /**
     * User\'s first name.
     */
    'firstName'?: string | null;
    /**
     * User\'s last name.
     */
    'lastName'?: string | null;
    /**
     * User\'s job.
     */
    'job'?: string | null;
    /**
     * User\'s  email address.
     */
    'emailAddress'?: string | null;
    /**
     * User\'s phone.
     */
    'phone'?: string | null;
    /**
     * User\'s notes.
     */
    'notes'?: string | null;
    /**
     * Not active users are not allowed to login
     */
    'isActive': boolean;
    /**
     * Indicates if the user has completed his registration.
     */
    'isRegistered': boolean;
}
/**
 * Current user data.
 */
export interface RHIMAPOCustomerManagementWebV2ModelsUserDto {
    /**
     * User\'s active directory object identifier.
     */
    'aadObjectId'?: string | null;
    /**
     * User\'s identifier.
     */
    'id': string;
    /**
     * User\'s first name.
     */
    'firstName'?: string | null;
    /**
     * User\'s last name.
     */
    'lastName'?: string | null;
    /**
     * User\'s job.
     */
    'job'?: string | null;
    /**
     * User\'s  email address.
     */
    'emailAddress'?: string | null;
    /**
     * User\'s phone.
     */
    'phone'?: string | null;
    /**
     * User\'s notes.
     */
    'notes'?: string | null;
    /**
     * Not active users are not allowed to login
     */
    'isActive': boolean;
    /**
     * Indicates if the user has completed his registration.
     */
    'isRegistered': boolean;
}
/**
 * Current user APO roles.
 */
export interface RHIMAPOCustomerManagementWebV2ModelsUserRolesDto {
    /**
     * Global roles.
     */
    'globalRoles'?: Array<RHIMAPOCoreWebRolesGlobalRole> | null;
    /**
     * Customer roles.
     */
    'customerRoles'?: Array<RHIMAPOCustomerManagementWebV2ModelsUserCustomerRoleDto> | null;
    /**
     * Customer Group roles.
     */
    'customerGroupRoles'?: Array<RHIMAPOCustomerManagementWebV2ModelsUserCustomerGroupRoleDto> | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsUserSettingsDto {
    'uiSettings'?: string | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsUserShortInfoDto {
    'id': string;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'email'?: string | null;
}
/**
 * User customer role to update.
 */
export interface RHIMAPOCustomerManagementWebV2ModelsUserUpdateCustomerGroupRoleRequestDto {
    /**
     * Customer id
     */
    'customerGroupId': string;
    /**
     * Customer roles
     */
    'customerGroupRoles': Array<RHIMAPOCoreWebRolesCustomerSpecificRole>;
}
/**
 * User customer role to update.
 */
export interface RHIMAPOCustomerManagementWebV2ModelsUserUpdateCustomerRoleRequestDto {
    /**
     * Customer id
     */
    'customerId': string;
    /**
     * Customer roles
     */
    'customerRoles': Array<RHIMAPOCoreWebRolesCustomerSpecificRole>;
}
/**
 * User data to update.
 */
export interface RHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto {
    /**
     * User\'s first name.  The field is required.
     */
    'firstName': string;
    /**
     * User\'s last name.  The field is required.
     */
    'lastName': string;
    /**
     * User\'s job.
     */
    'job'?: string | null;
    /**
     * User\'s  email address.  The field is required and must be unique.
     */
    'emailAddress': string;
    /**
     * User\'s phone.
     */
    'phone'?: string | null;
    /**
     * User\'s notes.
     */
    'notes'?: string | null;
    /**
     * Not active users are not allowed to login
     */
    'isActive': boolean;
}
/**
 * Describe user\'s global and customer roles
 */
export interface RHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto {
    /**
     * User\'s global roles.
     */
    'globalRoles'?: Array<RHIMAPOCoreWebRolesGlobalRole> | null;
    /**
     * User\'s customer roles.
     */
    'customerRoles'?: Array<RHIMAPOCustomerManagementWebV2ModelsUserUpdateCustomerRoleRequestDto> | null;
    /**
     * User\'s customer group roles.
     */
    'customerGroupRoles'?: Array<RHIMAPOCustomerManagementWebV2ModelsUserUpdateCustomerGroupRoleRequestDto> | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto {
    /**
     * Short unique vessel name.
     */
    'shortName': string;
    /**
     * Long not unique vessel name
     */
    'displayName': string;
    /**
     * Expected vessel heats.
     */
    'expectedHeats': number;
    /**
     * Vessel type.
     */
    'vesselType': string;
    /**
     * Customer id vessels belongs to.
     */
    'customerId': string;
}
export interface RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto {
    'outerVesselHeight'?: number | null;
    'upperPartHeight'?: number | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto {
    'outerVesselHeight'?: number | null;
    'outerVesselLength'?: number | null;
    'outerVesselWidth'?: number | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto {
    'outerVesselHeight'?: number | null;
    'outerVesselDiameter'?: number | null;
    /**
     * @deprecated
     */
    'enableKPIsInWms'?: boolean | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto {
    'outerVesselHeight'?: number | null;
    'outerVesselLength'?: number | null;
    'outerVesselWidth'?: number | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesDto {
    /**
     * The kiln length in meters. This value is derived from the inner kiln diameter segments.  This value can never be updated directly. It is always calculated from the inner kiln diameter segments.
     */
    'kilnLengthInMeters'?: number | null;
    /**
     * Where the running meter: 0 is located in a crk vessel
     */
    'runningMeterZeroLocation': RHIMAPOCustomerManagementWebServicesCrkVesselPropertiesCrkRunningMeterZeroLocation;
    /**
     * The diameter of the kiln at different running meters. Between values the diameter is linear.  The list should have always at least 2 values. For the start and the end of the kiln.  Example: [0.0] = 12.0, [60.0] = 12.0 -> A 60m long kiln with a constant diameter of 12m  Example: [0.0] = 10.0, [5.0] = 10.0, [6.0] = 12.0, [10.0] = 12    -> Between 0 and 5m the kiln has 10m diameter. And between 6 and 10m 12m diameter.    In between the is a linear progression from 5 to 6m.
     */
    'innerKilnDiameterSegments'?: Array<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesInnerKilnDiameterDto> | null;
}


export interface RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto {
    /**
     * Where the running meter: 0 is located in a crk vessel
     */
    'runningMeterZeroLocation': RHIMAPOCustomerManagementWebServicesCrkVesselPropertiesCrkRunningMeterZeroLocation;
    /**
     * The diameter of the kiln at different running meters. Between values the diameter is linear.  The list should have always at least 2 values. For the start and the end of the kiln.  Example: [0.0] = 12.0, [60.0] = 12.0 -> A 60m long kiln with a constant diameter of 12m  Example: [0.0] = 10.0, [5.0] = 10.0, [6.0] = 12.0, [10.0] = 12    -> Between 0 and 5m the kiln has 10m diameter. And between 6 and 10m 12m diameter.    In between the is a linear progression from 5 to 6m.
     */
    'innerKilnDiameterSegments'?: Array<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesInnerKilnDiameterDto> | null;
}


export interface RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto {
    'outerVesselHeight'?: number | null;
    'outerVesselDiameter'?: number | null;
    /**
     * @deprecated
     */
    'enableKPIsInWms'?: boolean | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto {
    'outerVesselHeight'?: number | null;
    'outerVesselDiameter'?: number | null;
    'innerVesselDiameter'?: number | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesInnerKilnDiameterDto {
    'rm': number;
    'diameter': number;
}
export interface RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto {
    'outerVesselHeight'?: number | null;
    'outerVesselDiameter'?: number | null;
    'innerVesselDiameter'?: number | null;
    /**
     * @deprecated
     */
    'enableKPIsInWms'?: boolean | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto {
    'outerVesselHeight'?: number | null;
    'outerVesselDiameter'?: number | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto {
    'outerVesselHeight'?: number | null;
    'outerVesselDiameter'?: number | null;
    'innerVesselDiameter'?: number | null;
    'snorkelHeight'?: number | null;
    'throatHeight'?: number | null;
    /**
     * @deprecated
     */
    'throatInOuterDiameter'?: number | null;
    /**
     * @deprecated
     */
    'throatOutOuterDiameter'?: number | null;
    /**
     * @deprecated
     */
    'throatInInnerDiameter'?: number | null;
    /**
     * @deprecated
     */
    'throatOutInnerDiameter'?: number | null;
    'snorkelInOuterDiameter'?: number | null;
    'snorkelOutOuterDiameter'?: number | null;
    'snorkelInInnerDiameter'?: number | null;
    'snorkelOutInnerDiameter'?: number | null;
    'throatDistance'?: number | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto {
    'outerVesselHeight'?: number | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto {
    'outerVesselHeight'?: number | null;
    'outerVesselLength'?: number | null;
    'outerVesselWidth'?: number | null;
}
export interface RHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto {
    /**
     * Long not unique vessel name
     */
    'displayName': string;
    /**
     * Expected vessel heats.
     */
    'expectedHeats': number;
}

export const RHIMContractsDisablingReason = {
    None: 'None',
    Unauthorized: 'Unauthorized',
    Expired: 'Expired',
    Invalid: 'Invalid',
    Misconfiguration: 'Misconfiguration',
} as const;

export type RHIMContractsDisablingReason = typeof RHIMContractsDisablingReason[keyof typeof RHIMContractsDisablingReason];



export const RHIMContractsExternalSystem = {
    CustomerPortal: 'CustomerPortal',
    Crm: 'CRM',
    Sap: 'SAP',
} as const;

export type RHIMContractsExternalSystem = typeof RHIMContractsExternalSystem[keyof typeof RHIMContractsExternalSystem];



export const RHIMContractsFeatureType = {
    Product: 'Product',
    External: 'External',
    PbiReport: 'PbiReport',
} as const;

export type RHIMContractsFeatureType = typeof RHIMContractsFeatureType[keyof typeof RHIMContractsFeatureType];



export const RHIMContractsFileType = {
    PostMortem: 'PostMortem',
    ProcessData: 'ProcessData',
    ProcessMetrixFiltered: 'ProcessMetrixFiltered',
    ProcessMetrixRaw: 'ProcessMetrixRaw',
    ProcessMetrixVertex: 'ProcessMetrixVertex',
    ProcessMetrixSummary: 'ProcessMetrixSummary',
    ProcessMetrixZip: 'ProcessMetrixZip',
    Stl: 'STL',
    HarmonizedSummary: 'HarmonizedSummary',
    ProcessDataSplit: 'ProcessDataSplit',
    Pts: 'PTS',
    Clinker: 'Clinker',
    KilnFeed: 'KilnFeed',
    HotMeal: 'HotMeal',
    Lignite: 'Lignite',
    StopLogs: 'StopLogs',
    IrScan: 'IRScan',
    KilnShellCooling: 'KilnShellCooling',
    KilnProcessData: 'KilnProcessData',
    FerrotronSummary: 'FerrotronSummary',
} as const;

export type RHIMContractsFileType = typeof RHIMContractsFileType[keyof typeof RHIMContractsFileType];



export const RHIMContractsHmdFeature = {
    LegacyRhView: 'LegacyRhView',
    QckLight: 'QCKLight',
    WearExplorer: 'WearExplorer',
    ParameterComparison: 'ParameterComparison',
    OperatorDisplay: 'OperatorDisplay',
    VolumeCalculations: 'VolumeCalculations',
    ConnectedMachines: 'ConnectedMachines',
} as const;

export type RHIMContractsHmdFeature = typeof RHIMContractsHmdFeature[keyof typeof RHIMContractsHmdFeature];



export const RHIMContractsIndustry = {
    Steel: 'Steel',
    CementAndLime: 'CementAndLime',
    Nfm: 'NFM',
    Eec: 'EEC',
    Glass: 'Glass',
    Foundry: 'Foundry',
    Minerals: 'Minerals',
    ProcessIndustries: 'ProcessIndustries',
    Internal: 'Internal',
} as const;

export type RHIMContractsIndustry = typeof RHIMContractsIndustry[keyof typeof RHIMContractsIndustry];



export const RHIMContractsProduct = {
    CustomerPortal: 'CustomerPortal',
    Hmd: 'Hmd',
} as const;

export type RHIMContractsProduct = typeof RHIMContractsProduct[keyof typeof RHIMContractsProduct];



export const RHIMContractsVesselType = {
    Bof: 'BOF',
    Rh: 'RH',
    Eaf: 'EAF',
    Ladle: 'Ladle',
    Crk: 'CRK',
    Rhl: 'RHL',
    Aod: 'AOD',
    Bfr: 'BFR',
    Srf: 'SRF',
    Cou: 'COU',
    Hml: 'HML',
    Cco: 'CCO',
    Ccy: 'CCY',
    Cca: 'CCA',
    Tun: 'TUN',
    Pcg: 'PCG',
    Hof: 'HOF',
    Anf: 'ANF',
    Maf: 'MAF',
    Tif: 'TIF',
    Shf: 'SHF',
} as const;

export type RHIMContractsVesselType = typeof RHIMContractsVesselType[keyof typeof RHIMContractsVesselType];


export interface RHIMHMDCustomerManagementContractsV2CustomerCustomerDto {
    'id': string;
    'shortName': string;
    'obfuscatedShortName': string;
    'displayName': string;
    'industry': string;
    'location': RHIMHMDCustomerManagementContractsV2CustomerCustomerLocationDto;
    'timeZoneName': string;
    'city': string;
    'country': string;
    'regionCode': string;
}
export interface RHIMHMDCustomerManagementContractsV2CustomerCustomerLocationDto {
    'latitude': number;
    'longitude': number;
}
export interface RHIMHMDCustomerManagementContractsV2CustomerCustomerSummaryDto {
    'customerId': string;
    'customerShortName': string;
    'customerDisplayName': string;
    'features': Array<RHIMContractsHmdFeature>;
    'operations': Array<string>;
}
export interface RHIMHMDCustomerManagementContractsV2CustomerVesselDto {
    'id': string;
    'vesselType': string;
    'customerId': string;
    'shortName': string;
    'displayName': string;
    'expectedHeats': number;
    'customer'?: RHIMHMDCustomerManagementContractsV2CustomerCustomerDto | null;
}
export interface RHIMHMDCustomerManagementContractsV2FeaturesFeatureCategoryDto {
    'name': string;
    'position': number;
    'features': Array<RHIMHMDCustomerManagementContractsV2FeaturesFeatureDto>;
}
export interface RHIMHMDCustomerManagementContractsV2FeaturesFeatureDto {
    'isDisabled': boolean;
    'name': string;
    'displayName'?: string | null;
    'description'?: string | null;
    'position': number;
    'featureType': RHIMContractsFeatureType;
    'uri': string;
    'disablingReason': RHIMContractsDisablingReason;
}


export interface RHIMHMDCustomerManagementContractsV2FeaturesFeatureTemplateDto {
    'name': string;
    'displayName': string;
    'featureType': RHIMContractsFeatureType;
}


export interface RHIMHMDCustomerManagementContractsV2UserUserInfoResponseDto {
    'customers': Array<RHIMHMDCustomerManagementContractsV2CustomerCustomerSummaryDto>;
    'globalOperations': Array<string>;
    'userSettings': string;
}

/**
 * ContactTypesApi - axios parameter creator
 */
export const ContactTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all contact types.
         * @summary Get all contact types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContacttypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ContactTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactTypesApi - functional programming interface
 */
export const ContactTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all contact types.
         * @summary Get all contact types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContacttypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOCommonDataCustomerManagementContactType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContacttypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactTypesApi.getContacttypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContactTypesApi - factory interface
 */
export const ContactTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactTypesApiFp(configuration)
    return {
        /**
         * Get all contact types.
         * @summary Get all contact types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContacttypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOCommonDataCustomerManagementContactType>> {
            return localVarFp.getContacttypes(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContactTypesApi - object-oriented interface
 */
export class ContactTypesApi extends BaseAPI {
    /**
     * Get all contact types.
     * @summary Get all contact types.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getContacttypes(options?: RawAxiosRequestConfig) {
        return ContactTypesApiFp(this.configuration).getContacttypes(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContactUsApi - axios parameter creator
 */
export const ContactUsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /ContactUs - POST
         * @param {RHIMAPOCustomerManagementWebV2ModelsContactUsDto} [rHIMAPOCustomerManagementWebV2ModelsContactUsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postContactus: async (rHIMAPOCustomerManagementWebV2ModelsContactUsDto?: RHIMAPOCustomerManagementWebV2ModelsContactUsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ContactUs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsContactUsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactUsApi - functional programming interface
 */
export const ContactUsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactUsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /ContactUs - POST
         * @param {RHIMAPOCustomerManagementWebV2ModelsContactUsDto} [rHIMAPOCustomerManagementWebV2ModelsContactUsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postContactus(rHIMAPOCustomerManagementWebV2ModelsContactUsDto?: RHIMAPOCustomerManagementWebV2ModelsContactUsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postContactus(rHIMAPOCustomerManagementWebV2ModelsContactUsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactUsApi.postContactus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContactUsApi - factory interface
 */
export const ContactUsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactUsApiFp(configuration)
    return {
        /**
         * 
         * @summary /ContactUs - POST
         * @param {RHIMAPOCustomerManagementWebV2ModelsContactUsDto} [rHIMAPOCustomerManagementWebV2ModelsContactUsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postContactus(rHIMAPOCustomerManagementWebV2ModelsContactUsDto?: RHIMAPOCustomerManagementWebV2ModelsContactUsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postContactus(rHIMAPOCustomerManagementWebV2ModelsContactUsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContactUsApi - object-oriented interface
 */
export class ContactUsApi extends BaseAPI {
    /**
     * 
     * @summary /ContactUs - POST
     * @param {RHIMAPOCustomerManagementWebV2ModelsContactUsDto} [rHIMAPOCustomerManagementWebV2ModelsContactUsDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postContactus(rHIMAPOCustomerManagementWebV2ModelsContactUsDto?: RHIMAPOCustomerManagementWebV2ModelsContactUsDto, options?: RawAxiosRequestConfig) {
        return ContactUsApiFp(this.configuration).postContactus(rHIMAPOCustomerManagementWebV2ModelsContactUsDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerExternalReferencesApi - axios parameter creator
 */
export const CustomerExternalReferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the external references of the customer
         * @summary Get the external references of the customer
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerexternalreferencesCustomerid: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomerexternalreferencesCustomerid', 'customerId', customerId)
            const localVarPath = `/CustomerExternalReferences/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the customerIds that are mapped to a given external reference
         * @summary Get the customerIds that are mapped to a given external reference
         * @param {string} externalSystem 
         * @param {string} foreignKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerexternalreferencesResolveExternalsystemForeignkey: async (externalSystem: string, foreignKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalSystem' is not null or undefined
            assertParamExists('getCustomerexternalreferencesResolveExternalsystemForeignkey', 'externalSystem', externalSystem)
            // verify required parameter 'foreignKey' is not null or undefined
            assertParamExists('getCustomerexternalreferencesResolveExternalsystemForeignkey', 'foreignKey', foreignKey)
            const localVarPath = `/CustomerExternalReferences/resolve/{externalSystem}/{foreignKey}`
                .replace('{externalSystem}', encodeURIComponent(String(externalSystem)))
                .replace('{foreignKey}', encodeURIComponent(String(foreignKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the external references of the customer
         * @summary Updates the external references of the customer
         * @param {string} customerId Identifier of the customer
         * @param {RHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto} [rHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto] The new external references
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomerexternalreferencesCustomerid: async (customerId: string, rHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto?: RHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('putCustomerexternalreferencesCustomerid', 'customerId', customerId)
            const localVarPath = `/CustomerExternalReferences/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerExternalReferencesApi - functional programming interface
 */
export const CustomerExternalReferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerExternalReferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the external references of the customer
         * @summary Get the external references of the customer
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerexternalreferencesCustomerid(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsExternalReferencesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerexternalreferencesCustomerid(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerExternalReferencesApi.getCustomerexternalreferencesCustomerid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the customerIds that are mapped to a given external reference
         * @summary Get the customerIds that are mapped to a given external reference
         * @param {string} externalSystem 
         * @param {string} foreignKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerexternalreferencesResolveExternalsystemForeignkey(externalSystem: string, foreignKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerexternalreferencesResolveExternalsystemForeignkey(externalSystem, foreignKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerExternalReferencesApi.getCustomerexternalreferencesResolveExternalsystemForeignkey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the external references of the customer
         * @summary Updates the external references of the customer
         * @param {string} customerId Identifier of the customer
         * @param {RHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto} [rHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto] The new external references
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putCustomerexternalreferencesCustomerid(customerId: string, rHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto?: RHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putCustomerexternalreferencesCustomerid(customerId, rHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerExternalReferencesApi.putCustomerexternalreferencesCustomerid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerExternalReferencesApi - factory interface
 */
export const CustomerExternalReferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerExternalReferencesApiFp(configuration)
    return {
        /**
         * Get the external references of the customer
         * @summary Get the external references of the customer
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerexternalreferencesCustomerid(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsExternalReferencesDto> {
            return localVarFp.getCustomerexternalreferencesCustomerid(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the customerIds that are mapped to a given external reference
         * @summary Get the customerIds that are mapped to a given external reference
         * @param {string} externalSystem 
         * @param {string} foreignKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerexternalreferencesResolveExternalsystemForeignkey(externalSystem: string, foreignKey: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getCustomerexternalreferencesResolveExternalsystemForeignkey(externalSystem, foreignKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the external references of the customer
         * @summary Updates the external references of the customer
         * @param {string} customerId Identifier of the customer
         * @param {RHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto} [rHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto] The new external references
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomerexternalreferencesCustomerid(customerId: string, rHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto?: RHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putCustomerexternalreferencesCustomerid(customerId, rHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerExternalReferencesApi - object-oriented interface
 */
export class CustomerExternalReferencesApi extends BaseAPI {
    /**
     * Get the external references of the customer
     * @summary Get the external references of the customer
     * @param {string} customerId Identifier of the customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomerexternalreferencesCustomerid(customerId: string, options?: RawAxiosRequestConfig) {
        return CustomerExternalReferencesApiFp(this.configuration).getCustomerexternalreferencesCustomerid(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the customerIds that are mapped to a given external reference
     * @summary Get the customerIds that are mapped to a given external reference
     * @param {string} externalSystem 
     * @param {string} foreignKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomerexternalreferencesResolveExternalsystemForeignkey(externalSystem: string, foreignKey: string, options?: RawAxiosRequestConfig) {
        return CustomerExternalReferencesApiFp(this.configuration).getCustomerexternalreferencesResolveExternalsystemForeignkey(externalSystem, foreignKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the external references of the customer
     * @summary Updates the external references of the customer
     * @param {string} customerId Identifier of the customer
     * @param {RHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto} [rHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto] The new external references
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putCustomerexternalreferencesCustomerid(customerId: string, rHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto?: RHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto, options?: RawAxiosRequestConfig) {
        return CustomerExternalReferencesApiFp(this.configuration).putCustomerexternalreferencesCustomerid(customerId, rHIMAPOCustomerManagementWebV2ModelsUpdateExternalReferencesDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerGroupsApi - axios parameter creator
 */
export const CustomerGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a customer group
         * @summary Delete a customer group
         * @param {string} customerGroupId Identifier of the customer group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomergroupsCustomergroupid: async (customerGroupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerGroupId' is not null or undefined
            assertParamExists('deleteCustomergroupsCustomergroupid', 'customerGroupId', customerGroupId)
            const localVarPath = `/CustomerGroups/{customerGroupId}`
                .replace('{customerGroupId}', encodeURIComponent(String(customerGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all customer groups and their assignments
         * @summary Retrieves all customer groups and their assignments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomergroups: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/CustomerGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all customer groups for a specific customer
         * @summary Retrieves all customer groups for a specific customer
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomergroupsCustomerCustomerid: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomergroupsCustomerCustomerid', 'customerId', customerId)
            const localVarPath = `/CustomerGroups/customer/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves one customer group and its assignments
         * @summary Retrieves one customer group and its assignments
         * @param {string} customerGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomergroupsCustomergroupid: async (customerGroupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerGroupId' is not null or undefined
            assertParamExists('getCustomergroupsCustomergroupid', 'customerGroupId', customerGroupId)
            const localVarPath = `/CustomerGroups/{customerGroupId}`
                .replace('{customerGroupId}', encodeURIComponent(String(customerGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a customer group by id
         * @summary Creates a customer group by id
         * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCustomergroups: async (rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/CustomerGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a customer group by id
         * @summary Updates a customer group by id
         * @param {string} customerGroupId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomergroupsCustomergroupid: async (customerGroupId: string, rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerGroupId' is not null or undefined
            assertParamExists('putCustomergroupsCustomergroupid', 'customerGroupId', customerGroupId)
            const localVarPath = `/CustomerGroups/{customerGroupId}`
                .replace('{customerGroupId}', encodeURIComponent(String(customerGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerGroupsApi - functional programming interface
 */
export const CustomerGroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerGroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a customer group
         * @summary Delete a customer group
         * @param {string} customerGroupId Identifier of the customer group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomergroupsCustomergroupid(customerGroupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomergroupsCustomergroupid(customerGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerGroupsApi.deleteCustomergroupsCustomergroupid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all customer groups and their assignments
         * @summary Retrieves all customer groups and their assignments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomergroups(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOCustomerManagementWebV2ModelsCustomerGroupDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomergroups(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerGroupsApi.getCustomergroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all customer groups for a specific customer
         * @summary Retrieves all customer groups for a specific customer
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomergroupsCustomerCustomerid(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOCustomerManagementWebV2ModelsCustomerGroupDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomergroupsCustomerCustomerid(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerGroupsApi.getCustomergroupsCustomerCustomerid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves one customer group and its assignments
         * @summary Retrieves one customer group and its assignments
         * @param {string} customerGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomergroupsCustomergroupid(customerGroupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsCustomerGroupDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomergroupsCustomergroupid(customerGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerGroupsApi.getCustomergroupsCustomergroupid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a customer group by id
         * @summary Creates a customer group by id
         * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCustomergroups(rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsCustomerGroupDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCustomergroups(rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerGroupsApi.postCustomergroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a customer group by id
         * @summary Updates a customer group by id
         * @param {string} customerGroupId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putCustomergroupsCustomergroupid(customerGroupId: string, rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putCustomergroupsCustomergroupid(customerGroupId, rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerGroupsApi.putCustomergroupsCustomergroupid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerGroupsApi - factory interface
 */
export const CustomerGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerGroupsApiFp(configuration)
    return {
        /**
         * Delete a customer group
         * @summary Delete a customer group
         * @param {string} customerGroupId Identifier of the customer group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomergroupsCustomergroupid(customerGroupId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCustomergroupsCustomergroupid(customerGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all customer groups and their assignments
         * @summary Retrieves all customer groups and their assignments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomergroups(options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOCustomerManagementWebV2ModelsCustomerGroupDto>> {
            return localVarFp.getCustomergroups(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all customer groups for a specific customer
         * @summary Retrieves all customer groups for a specific customer
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomergroupsCustomerCustomerid(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOCustomerManagementWebV2ModelsCustomerGroupDto>> {
            return localVarFp.getCustomergroupsCustomerCustomerid(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves one customer group and its assignments
         * @summary Retrieves one customer group and its assignments
         * @param {string} customerGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomergroupsCustomergroupid(customerGroupId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsCustomerGroupDto> {
            return localVarFp.getCustomergroupsCustomergroupid(customerGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a customer group by id
         * @summary Creates a customer group by id
         * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCustomergroups(rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsCustomerGroupDto> {
            return localVarFp.postCustomergroups(rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a customer group by id
         * @summary Updates a customer group by id
         * @param {string} customerGroupId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomergroupsCustomergroupid(customerGroupId: string, rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putCustomergroupsCustomergroupid(customerGroupId, rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerGroupsApi - object-oriented interface
 */
export class CustomerGroupsApi extends BaseAPI {
    /**
     * Delete a customer group
     * @summary Delete a customer group
     * @param {string} customerGroupId Identifier of the customer group
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCustomergroupsCustomergroupid(customerGroupId: string, options?: RawAxiosRequestConfig) {
        return CustomerGroupsApiFp(this.configuration).deleteCustomergroupsCustomergroupid(customerGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all customer groups and their assignments
     * @summary Retrieves all customer groups and their assignments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomergroups(options?: RawAxiosRequestConfig) {
        return CustomerGroupsApiFp(this.configuration).getCustomergroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all customer groups for a specific customer
     * @summary Retrieves all customer groups for a specific customer
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomergroupsCustomerCustomerid(customerId: string, options?: RawAxiosRequestConfig) {
        return CustomerGroupsApiFp(this.configuration).getCustomergroupsCustomerCustomerid(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves one customer group and its assignments
     * @summary Retrieves one customer group and its assignments
     * @param {string} customerGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomergroupsCustomergroupid(customerGroupId: string, options?: RawAxiosRequestConfig) {
        return CustomerGroupsApiFp(this.configuration).getCustomergroupsCustomergroupid(customerGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a customer group by id
     * @summary Creates a customer group by id
     * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postCustomergroups(rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto, options?: RawAxiosRequestConfig) {
        return CustomerGroupsApiFp(this.configuration).postCustomergroups(rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a customer group by id
     * @summary Updates a customer group by id
     * @param {string} customerGroupId 
     * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putCustomergroupsCustomergroupid(customerGroupId: string, rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto, options?: RawAxiosRequestConfig) {
        return CustomerGroupsApiFp(this.configuration).putCustomergroupsCustomergroupid(customerGroupId, rHIMAPOCustomerManagementWebV2ModelsCustomerGroupCreateOrUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerOverviewApi - axios parameter creator
 */
export const CustomerOverviewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves all data for the customer overview
         * @summary Retrieves all data for the customer overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomeroverview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/CustomerOverview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerOverviewApi - functional programming interface
 */
export const CustomerOverviewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerOverviewApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves all data for the customer overview
         * @summary Retrieves all data for the customer overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomeroverview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOCustomerManagementWebV2ModelsCustomerOverviewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomeroverview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerOverviewApi.getCustomeroverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerOverviewApi - factory interface
 */
export const CustomerOverviewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerOverviewApiFp(configuration)
    return {
        /**
         * Retrieves all data for the customer overview
         * @summary Retrieves all data for the customer overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomeroverview(options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOCustomerManagementWebV2ModelsCustomerOverviewDto>> {
            return localVarFp.getCustomeroverview(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerOverviewApi - object-oriented interface
 */
export class CustomerOverviewApi extends BaseAPI {
    /**
     * Retrieves all data for the customer overview
     * @summary Retrieves all data for the customer overview
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomeroverview(options?: RawAxiosRequestConfig) {
        return CustomerOverviewApiFp(this.configuration).getCustomeroverview(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomersApi - axios parameter creator
 */
export const CustomersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a customer by id
         * @summary Delete a customer by id
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomersCustomerid: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteCustomersCustomerid', 'customerId', customerId)
            const localVarPath = `/Customers/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all customers
         * @summary Retrieves all customers
         * @param {string} [ingressContactMailAddress] Filter customers that have a contact person with mail address and type IngressMailSender
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers: async (ingressContactMailAddress?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ingressContactMailAddress !== undefined) {
                localVarQueryParameter['ingressContactMailAddress'] = ingressContactMailAddress;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a customer by its id
         * @summary Retrieves a customer by its id
         * @param {string} customerId Id of the customer to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersCustomerid: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomersCustomerid', 'customerId', customerId)
            const localVarPath = `/Customers/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all customer contact persons by customer id
         * @summary Retrieves all customer contact persons by customer id
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersCustomeridContactpersons: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomersCustomeridContactpersons', 'customerId', customerId)
            const localVarPath = `/Customers/{customerId}/contactpersons`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all direct role assignments of a customer.  Global assignments or customer group assignments are not counted
         * @summary Retrieves all direct role assignments of a customer.  Global assignments or customer group assignments are not counted
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersCustomeridRoleassignments: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomersCustomeridRoleassignments', 'customerId', customerId)
            const localVarPath = `/Customers/{customerId}/roleassignments`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /customers/00000000-0000-0000-0001-000000000000/vessels  GET /customers/00000000-0000-0000-0001-000000000000/vessels?vesselType=0
         * @summary Retrieves all vessels which are assigned to a customer
         * @param {string} customerId Identifier of the customer
         * @param {string} [vesselType] The optional vesselType to filter the vessels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersCustomeridVessels: async (customerId: string, vesselType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomersCustomeridVessels', 'customerId', customerId)
            const localVarPath = `/Customers/{customerId}/vessels`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vesselType !== undefined) {
                localVarQueryParameter['vesselType'] = vesselType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new customer
         * @summary Creates a new customer
         * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto] The json body which contains info about the new customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCustomers: async (rHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a customer by its id
         * @summary Updates a customer by its id
         * @param {string} customerId Identifier of the customer
         * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto] The updated customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomersCustomerid: async (customerId: string, rHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('putCustomersCustomerid', 'customerId', customerId)
            const localVarPath = `/Customers/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update all customer contact persons by customer id
         * @summary Update all customer contact persons by customer id
         * @param {string} customerId Identifier of the customer
         * @param {Array<RHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto>} [rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto] A list of customer contact persons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomersCustomeridContactpersons: async (customerId: string, rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto?: Array<RHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('putCustomersCustomeridContactpersons', 'customerId', customerId)
            const localVarPath = `/Customers/{customerId}/contactpersons`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersApi - functional programming interface
 */
export const CustomersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomersApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a customer by id
         * @summary Delete a customer by id
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomersCustomerid(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomersCustomerid(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.deleteCustomersCustomerid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all customers
         * @summary Retrieves all customers
         * @param {string} [ingressContactMailAddress] Filter customers that have a contact person with mail address and type IngressMailSender
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomers(ingressContactMailAddress?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMHMDCustomerManagementContractsV2CustomerCustomerDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomers(ingressContactMailAddress, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a customer by its id
         * @summary Retrieves a customer by its id
         * @param {string} customerId Id of the customer to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomersCustomerid(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMHMDCustomerManagementContractsV2CustomerCustomerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomersCustomerid(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCustomersCustomerid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all customer contact persons by customer id
         * @summary Retrieves all customer contact persons by customer id
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomersCustomeridContactpersons(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOCustomerManagementWebV2ModelsContactPersonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomersCustomeridContactpersons(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCustomersCustomeridContactpersons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all direct role assignments of a customer.  Global assignments or customer group assignments are not counted
         * @summary Retrieves all direct role assignments of a customer.  Global assignments or customer group assignments are not counted
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomersCustomeridRoleassignments(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOCustomerManagementWebV2ModelsCustomerRoleAssignmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomersCustomeridRoleassignments(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCustomersCustomeridRoleassignments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /customers/00000000-0000-0000-0001-000000000000/vessels  GET /customers/00000000-0000-0000-0001-000000000000/vessels?vesselType=0
         * @summary Retrieves all vessels which are assigned to a customer
         * @param {string} customerId Identifier of the customer
         * @param {string} [vesselType] The optional vesselType to filter the vessels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomersCustomeridVessels(customerId: string, vesselType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMHMDCustomerManagementContractsV2CustomerVesselDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomersCustomeridVessels(customerId, vesselType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCustomersCustomeridVessels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new customer
         * @summary Creates a new customer
         * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto] The json body which contains info about the new customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCustomers(rHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMHMDCustomerManagementContractsV2CustomerCustomerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCustomers(rHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.postCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a customer by its id
         * @summary Updates a customer by its id
         * @param {string} customerId Identifier of the customer
         * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto] The updated customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putCustomersCustomerid(customerId: string, rHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putCustomersCustomerid(customerId, rHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.putCustomersCustomerid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update all customer contact persons by customer id
         * @summary Update all customer contact persons by customer id
         * @param {string} customerId Identifier of the customer
         * @param {Array<RHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto>} [rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto] A list of customer contact persons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putCustomersCustomeridContactpersons(customerId: string, rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto?: Array<RHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putCustomersCustomeridContactpersons(customerId, rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.putCustomersCustomeridContactpersons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomersApi - factory interface
 */
export const CustomersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomersApiFp(configuration)
    return {
        /**
         * Delete a customer by id
         * @summary Delete a customer by id
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomersCustomerid(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCustomersCustomerid(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all customers
         * @summary Retrieves all customers
         * @param {string} [ingressContactMailAddress] Filter customers that have a contact person with mail address and type IngressMailSender
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers(ingressContactMailAddress?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMHMDCustomerManagementContractsV2CustomerCustomerDto>> {
            return localVarFp.getCustomers(ingressContactMailAddress, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a customer by its id
         * @summary Retrieves a customer by its id
         * @param {string} customerId Id of the customer to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersCustomerid(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMHMDCustomerManagementContractsV2CustomerCustomerDto> {
            return localVarFp.getCustomersCustomerid(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all customer contact persons by customer id
         * @summary Retrieves all customer contact persons by customer id
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersCustomeridContactpersons(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOCustomerManagementWebV2ModelsContactPersonDto>> {
            return localVarFp.getCustomersCustomeridContactpersons(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all direct role assignments of a customer.  Global assignments or customer group assignments are not counted
         * @summary Retrieves all direct role assignments of a customer.  Global assignments or customer group assignments are not counted
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersCustomeridRoleassignments(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOCustomerManagementWebV2ModelsCustomerRoleAssignmentDto>> {
            return localVarFp.getCustomersCustomeridRoleassignments(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /customers/00000000-0000-0000-0001-000000000000/vessels  GET /customers/00000000-0000-0000-0001-000000000000/vessels?vesselType=0
         * @summary Retrieves all vessels which are assigned to a customer
         * @param {string} customerId Identifier of the customer
         * @param {string} [vesselType] The optional vesselType to filter the vessels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersCustomeridVessels(customerId: string, vesselType?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMHMDCustomerManagementContractsV2CustomerVesselDto>> {
            return localVarFp.getCustomersCustomeridVessels(customerId, vesselType, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new customer
         * @summary Creates a new customer
         * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto] The json body which contains info about the new customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCustomers(rHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMHMDCustomerManagementContractsV2CustomerCustomerDto> {
            return localVarFp.postCustomers(rHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a customer by its id
         * @summary Updates a customer by its id
         * @param {string} customerId Identifier of the customer
         * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto] The updated customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomersCustomerid(customerId: string, rHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putCustomersCustomerid(customerId, rHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update all customer contact persons by customer id
         * @summary Update all customer contact persons by customer id
         * @param {string} customerId Identifier of the customer
         * @param {Array<RHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto>} [rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto] A list of customer contact persons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomersCustomeridContactpersons(customerId: string, rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto?: Array<RHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putCustomersCustomeridContactpersons(customerId, rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomersApi - object-oriented interface
 */
export class CustomersApi extends BaseAPI {
    /**
     * Delete a customer by id
     * @summary Delete a customer by id
     * @param {string} customerId Identifier of the customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCustomersCustomerid(customerId: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).deleteCustomersCustomerid(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all customers
     * @summary Retrieves all customers
     * @param {string} [ingressContactMailAddress] Filter customers that have a contact person with mail address and type IngressMailSender
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomers(ingressContactMailAddress?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomers(ingressContactMailAddress, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a customer by its id
     * @summary Retrieves a customer by its id
     * @param {string} customerId Id of the customer to be retrieved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomersCustomerid(customerId: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomersCustomerid(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all customer contact persons by customer id
     * @summary Retrieves all customer contact persons by customer id
     * @param {string} customerId Identifier of the customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomersCustomeridContactpersons(customerId: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomersCustomeridContactpersons(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all direct role assignments of a customer.  Global assignments or customer group assignments are not counted
     * @summary Retrieves all direct role assignments of a customer.  Global assignments or customer group assignments are not counted
     * @param {string} customerId Identifier of the customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomersCustomeridRoleassignments(customerId: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomersCustomeridRoleassignments(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /customers/00000000-0000-0000-0001-000000000000/vessels  GET /customers/00000000-0000-0000-0001-000000000000/vessels?vesselType=0
     * @summary Retrieves all vessels which are assigned to a customer
     * @param {string} customerId Identifier of the customer
     * @param {string} [vesselType] The optional vesselType to filter the vessels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomersCustomeridVessels(customerId: string, vesselType?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomersCustomeridVessels(customerId, vesselType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new customer
     * @summary Creates a new customer
     * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto] The json body which contains info about the new customer.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postCustomers(rHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).postCustomers(rHIMAPOCustomerManagementWebV2ModelsCustomerCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a customer by its id
     * @summary Updates a customer by its id
     * @param {string} customerId Identifier of the customer
     * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto] The updated customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putCustomersCustomerid(customerId: string, rHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).putCustomersCustomerid(customerId, rHIMAPOCustomerManagementWebV2ModelsCustomerUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update all customer contact persons by customer id
     * @summary Update all customer contact persons by customer id
     * @param {string} customerId Identifier of the customer
     * @param {Array<RHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto>} [rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto] A list of customer contact persons
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putCustomersCustomeridContactpersons(customerId: string, rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto?: Array<RHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto>, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).putCustomersCustomeridContactpersons(customerId, rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ETechUriApi - axios parameter creator
 */
export const ETechUriApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generates a link to the E-Tech portal for the current user.
         * @summary Generates a link to the E-Tech portal for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtechuri: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ETechUri`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ETechUriApi - functional programming interface
 */
export const ETechUriApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ETechUriApiAxiosParamCreator(configuration)
    return {
        /**
         * Generates a link to the E-Tech portal for the current user.
         * @summary Generates a link to the E-Tech portal for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEtechuri(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEtechuri(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ETechUriApi.getEtechuri']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ETechUriApi - factory interface
 */
export const ETechUriApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ETechUriApiFp(configuration)
    return {
        /**
         * Generates a link to the E-Tech portal for the current user.
         * @summary Generates a link to the E-Tech portal for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtechuri(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getEtechuri(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ETechUriApi - object-oriented interface
 */
export class ETechUriApi extends BaseAPI {
    /**
     * Generates a link to the E-Tech portal for the current user.
     * @summary Generates a link to the E-Tech portal for the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEtechuri(options?: RawAxiosRequestConfig) {
        return ETechUriApiFp(this.configuration).getEtechuri(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FeatureApi - axios parameter creator
 */
export const FeatureApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /Feature/{product}/{customerId} - GET
         * @param {string} product 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureProductCustomerid: async (product: string, customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'product' is not null or undefined
            assertParamExists('getFeatureProductCustomerid', 'product', product)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getFeatureProductCustomerid', 'customerId', customerId)
            const localVarPath = `/Feature/{product}/{customerId}`
                .replace('{product}', encodeURIComponent(String(product)))
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeatureApi - functional programming interface
 */
export const FeatureApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeatureApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /Feature/{product}/{customerId} - GET
         * @param {string} product 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatureProductCustomerid(product: string, customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMHMDCustomerManagementContractsV2FeaturesFeatureCategoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatureProductCustomerid(product, customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureApi.getFeatureProductCustomerid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeatureApi - factory interface
 */
export const FeatureApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeatureApiFp(configuration)
    return {
        /**
         * 
         * @summary /Feature/{product}/{customerId} - GET
         * @param {string} product 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureProductCustomerid(product: string, customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMHMDCustomerManagementContractsV2FeaturesFeatureCategoryDto>> {
            return localVarFp.getFeatureProductCustomerid(product, customerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeatureApi - object-oriented interface
 */
export class FeatureApi extends BaseAPI {
    /**
     * 
     * @summary /Feature/{product}/{customerId} - GET
     * @param {string} product 
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFeatureProductCustomerid(product: string, customerId: string, options?: RawAxiosRequestConfig) {
        return FeatureApiFp(this.configuration).getFeatureProductCustomerid(product, customerId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FeatureAssignmentsApi - axios parameter creator
 */
export const FeatureAssignmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Remove feature from a customer
         * @summary Remove feature from a customer
         * @param {string} customerId Customer id to identify the customer
         * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto] Feature data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomersCustomeridFeatures: async (customerId: string, rHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteCustomersCustomeridFeatures', 'customerId', customerId)
            const localVarPath = `/customers/{customerId}/features`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all feature assignments of a customer
         * @summary Retrieves all feature assignments of a customer
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersCustomeridFeatures: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomersCustomeridFeatures', 'customerId', customerId)
            const localVarPath = `/customers/{customerId}/features`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add feature to a customer
         * @summary Add feature to a customer
         * @param {string} customerId Customer id to identify the customer
         * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto] Feature data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCustomersCustomeridFeatures: async (customerId: string, rHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('postCustomersCustomeridFeatures', 'customerId', customerId)
            const localVarPath = `/customers/{customerId}/features`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeatureAssignmentsApi - functional programming interface
 */
export const FeatureAssignmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeatureAssignmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Remove feature from a customer
         * @summary Remove feature from a customer
         * @param {string} customerId Customer id to identify the customer
         * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto] Feature data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomersCustomeridFeatures(customerId: string, rHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomersCustomeridFeatures(customerId, rHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureAssignmentsApi.deleteCustomersCustomeridFeatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all feature assignments of a customer
         * @summary Retrieves all feature assignments of a customer
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomersCustomeridFeatures(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMContractsHmdFeature>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomersCustomeridFeatures(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureAssignmentsApi.getCustomersCustomeridFeatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add feature to a customer
         * @summary Add feature to a customer
         * @param {string} customerId Customer id to identify the customer
         * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto] Feature data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCustomersCustomeridFeatures(customerId: string, rHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCustomersCustomeridFeatures(customerId, rHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureAssignmentsApi.postCustomersCustomeridFeatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeatureAssignmentsApi - factory interface
 */
export const FeatureAssignmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeatureAssignmentsApiFp(configuration)
    return {
        /**
         * Remove feature from a customer
         * @summary Remove feature from a customer
         * @param {string} customerId Customer id to identify the customer
         * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto] Feature data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomersCustomeridFeatures(customerId: string, rHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCustomersCustomeridFeatures(customerId, rHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all feature assignments of a customer
         * @summary Retrieves all feature assignments of a customer
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersCustomeridFeatures(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMContractsHmdFeature>> {
            return localVarFp.getCustomersCustomeridFeatures(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add feature to a customer
         * @summary Add feature to a customer
         * @param {string} customerId Customer id to identify the customer
         * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto] Feature data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCustomersCustomeridFeatures(customerId: string, rHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postCustomersCustomeridFeatures(customerId, rHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeatureAssignmentsApi - object-oriented interface
 */
export class FeatureAssignmentsApi extends BaseAPI {
    /**
     * Remove feature from a customer
     * @summary Remove feature from a customer
     * @param {string} customerId Customer id to identify the customer
     * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto] Feature data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCustomersCustomeridFeatures(customerId: string, rHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto, options?: RawAxiosRequestConfig) {
        return FeatureAssignmentsApiFp(this.configuration).deleteCustomersCustomeridFeatures(customerId, rHIMAPOCustomerManagementWebV2ModelsCustomerRemoveFeatureRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all feature assignments of a customer
     * @summary Retrieves all feature assignments of a customer
     * @param {string} customerId Identifier of the customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomersCustomeridFeatures(customerId: string, options?: RawAxiosRequestConfig) {
        return FeatureAssignmentsApiFp(this.configuration).getCustomersCustomeridFeatures(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add feature to a customer
     * @summary Add feature to a customer
     * @param {string} customerId Customer id to identify the customer
     * @param {RHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto} [rHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto] Feature data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postCustomersCustomeridFeatures(customerId: string, rHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto?: RHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto, options?: RawAxiosRequestConfig) {
        return FeatureAssignmentsApiFp(this.configuration).postCustomersCustomeridFeatures(customerId, rHIMAPOCustomerManagementWebV2ModelsCustomerAddFeatureRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FeatureCategoryMaintenanceApi - axios parameter creator
 */
export const FeatureCategoryMaintenanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /FeatureCategoryMaintenance/{categoryId} - DELETE
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeaturecategorymaintenanceCategoryid: async (categoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('deleteFeaturecategorymaintenanceCategoryid', 'categoryId', categoryId)
            const localVarPath = `/FeatureCategoryMaintenance/{categoryId}`
                .replace('{categoryId}', encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /FeatureCategoryMaintenance/{categoryId} - POST
         * @param {string} categoryId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFeaturecategorymaintenanceCategoryid: async (categoryId: string, rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('postFeaturecategorymaintenanceCategoryid', 'categoryId', categoryId)
            const localVarPath = `/FeatureCategoryMaintenance/{categoryId}`
                .replace('{categoryId}', encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /FeatureCategoryMaintenance/order/{product}/{customerId} - POST
         * @param {string} product 
         * @param {string} customerId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto} [rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFeaturecategorymaintenanceOrderProductCustomerid: async (product: string, customerId: string, rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto?: RHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'product' is not null or undefined
            assertParamExists('postFeaturecategorymaintenanceOrderProductCustomerid', 'product', product)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('postFeaturecategorymaintenanceOrderProductCustomerid', 'customerId', customerId)
            const localVarPath = `/FeatureCategoryMaintenance/order/{product}/{customerId}`
                .replace('{product}', encodeURIComponent(String(product)))
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /FeatureCategoryMaintenance/{product}/{customerId} - PUT
         * @param {string} product 
         * @param {string} customerId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto} [rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFeaturecategorymaintenanceProductCustomerid: async (product: string, customerId: string, rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto?: RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'product' is not null or undefined
            assertParamExists('putFeaturecategorymaintenanceProductCustomerid', 'product', product)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('putFeaturecategorymaintenanceProductCustomerid', 'customerId', customerId)
            const localVarPath = `/FeatureCategoryMaintenance/{product}/{customerId}`
                .replace('{product}', encodeURIComponent(String(product)))
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeatureCategoryMaintenanceApi - functional programming interface
 */
export const FeatureCategoryMaintenanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeatureCategoryMaintenanceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /FeatureCategoryMaintenance/{categoryId} - DELETE
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFeaturecategorymaintenanceCategoryid(categoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFeaturecategorymaintenanceCategoryid(categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureCategoryMaintenanceApi.deleteFeaturecategorymaintenanceCategoryid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /FeatureCategoryMaintenance/{categoryId} - POST
         * @param {string} categoryId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFeaturecategorymaintenanceCategoryid(categoryId: string, rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFeaturecategorymaintenanceCategoryid(categoryId, rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureCategoryMaintenanceApi.postFeaturecategorymaintenanceCategoryid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /FeatureCategoryMaintenance/order/{product}/{customerId} - POST
         * @param {string} product 
         * @param {string} customerId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto} [rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFeaturecategorymaintenanceOrderProductCustomerid(product: string, customerId: string, rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto?: RHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFeaturecategorymaintenanceOrderProductCustomerid(product, customerId, rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureCategoryMaintenanceApi.postFeaturecategorymaintenanceOrderProductCustomerid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /FeatureCategoryMaintenance/{product}/{customerId} - PUT
         * @param {string} product 
         * @param {string} customerId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto} [rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putFeaturecategorymaintenanceProductCustomerid(product: string, customerId: string, rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto?: RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryMaintenanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putFeaturecategorymaintenanceProductCustomerid(product, customerId, rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureCategoryMaintenanceApi.putFeaturecategorymaintenanceProductCustomerid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeatureCategoryMaintenanceApi - factory interface
 */
export const FeatureCategoryMaintenanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeatureCategoryMaintenanceApiFp(configuration)
    return {
        /**
         * 
         * @summary /FeatureCategoryMaintenance/{categoryId} - DELETE
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeaturecategorymaintenanceCategoryid(categoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteFeaturecategorymaintenanceCategoryid(categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /FeatureCategoryMaintenance/{categoryId} - POST
         * @param {string} categoryId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFeaturecategorymaintenanceCategoryid(categoryId: string, rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postFeaturecategorymaintenanceCategoryid(categoryId, rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /FeatureCategoryMaintenance/order/{product}/{customerId} - POST
         * @param {string} product 
         * @param {string} customerId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto} [rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFeaturecategorymaintenanceOrderProductCustomerid(product: string, customerId: string, rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto?: RHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postFeaturecategorymaintenanceOrderProductCustomerid(product, customerId, rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /FeatureCategoryMaintenance/{product}/{customerId} - PUT
         * @param {string} product 
         * @param {string} customerId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto} [rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFeaturecategorymaintenanceProductCustomerid(product: string, customerId: string, rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto?: RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryMaintenanceDto> {
            return localVarFp.putFeaturecategorymaintenanceProductCustomerid(product, customerId, rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeatureCategoryMaintenanceApi - object-oriented interface
 */
export class FeatureCategoryMaintenanceApi extends BaseAPI {
    /**
     * 
     * @summary /FeatureCategoryMaintenance/{categoryId} - DELETE
     * @param {string} categoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteFeaturecategorymaintenanceCategoryid(categoryId: string, options?: RawAxiosRequestConfig) {
        return FeatureCategoryMaintenanceApiFp(this.configuration).deleteFeaturecategorymaintenanceCategoryid(categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /FeatureCategoryMaintenance/{categoryId} - POST
     * @param {string} categoryId 
     * @param {RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postFeaturecategorymaintenanceCategoryid(categoryId: string, rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto, options?: RawAxiosRequestConfig) {
        return FeatureCategoryMaintenanceApiFp(this.configuration).postFeaturecategorymaintenanceCategoryid(categoryId, rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /FeatureCategoryMaintenance/order/{product}/{customerId} - POST
     * @param {string} product 
     * @param {string} customerId 
     * @param {RHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto} [rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postFeaturecategorymaintenanceOrderProductCustomerid(product: string, customerId: string, rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto?: RHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto, options?: RawAxiosRequestConfig) {
        return FeatureCategoryMaintenanceApiFp(this.configuration).postFeaturecategorymaintenanceOrderProductCustomerid(product, customerId, rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /FeatureCategoryMaintenance/{product}/{customerId} - PUT
     * @param {string} product 
     * @param {string} customerId 
     * @param {RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto} [rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putFeaturecategorymaintenanceProductCustomerid(product: string, customerId: string, rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto?: RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto, options?: RawAxiosRequestConfig) {
        return FeatureCategoryMaintenanceApiFp(this.configuration).putFeaturecategorymaintenanceProductCustomerid(product, customerId, rHIMAPOCustomerManagementWebV2ModelsFeatureCategoryAddDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FeatureMaintenanceApi - axios parameter creator
 */
export const FeatureMaintenanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /FeatureMaintenance/{featureId} - DELETE
         * @param {string} featureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeaturemaintenanceFeatureid: async (featureId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'featureId' is not null or undefined
            assertParamExists('deleteFeaturemaintenanceFeatureid', 'featureId', featureId)
            const localVarPath = `/FeatureMaintenance/{featureId}`
                .replace('{featureId}', encodeURIComponent(String(featureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /FeatureMaintenance/{product}/{customerId} - GET
         * @param {string} product 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturemaintenanceProductCustomerid: async (product: string, customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'product' is not null or undefined
            assertParamExists('getFeaturemaintenanceProductCustomerid', 'product', product)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getFeaturemaintenanceProductCustomerid', 'customerId', customerId)
            const localVarPath = `/FeatureMaintenance/{product}/{customerId}`
                .replace('{product}', encodeURIComponent(String(product)))
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /FeatureMaintenance/products - GET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturemaintenanceProducts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/FeatureMaintenance/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /FeatureMaintenance/templates/{product}/{customerId} - GET
         * @param {string} product 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturemaintenanceTemplatesProductCustomerid: async (product: string, customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'product' is not null or undefined
            assertParamExists('getFeaturemaintenanceTemplatesProductCustomerid', 'product', product)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getFeaturemaintenanceTemplatesProductCustomerid', 'customerId', customerId)
            const localVarPath = `/FeatureMaintenance/templates/{product}/{customerId}`
                .replace('{product}', encodeURIComponent(String(product)))
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /FeatureMaintenance/{featureId} - POST
         * @param {string} featureId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFeaturemaintenanceFeatureid: async (featureId: string, rHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'featureId' is not null or undefined
            assertParamExists('postFeaturemaintenanceFeatureid', 'featureId', featureId)
            const localVarPath = `/FeatureMaintenance/{featureId}`
                .replace('{featureId}', encodeURIComponent(String(featureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /FeatureMaintenance/order/{product}/{customerId} - POST
         * @param {string} product 
         * @param {string} customerId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto} [rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFeaturemaintenanceOrderProductCustomerid: async (product: string, customerId: string, rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto?: RHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'product' is not null or undefined
            assertParamExists('postFeaturemaintenanceOrderProductCustomerid', 'product', product)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('postFeaturemaintenanceOrderProductCustomerid', 'customerId', customerId)
            const localVarPath = `/FeatureMaintenance/order/{product}/{customerId}`
                .replace('{product}', encodeURIComponent(String(product)))
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /FeatureMaintenance/{categoryId} - PUT
         * @param {string} categoryId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsFeatureAddDto} [rHIMAPOCustomerManagementWebV2ModelsFeatureAddDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFeaturemaintenanceCategoryid: async (categoryId: string, rHIMAPOCustomerManagementWebV2ModelsFeatureAddDto?: RHIMAPOCustomerManagementWebV2ModelsFeatureAddDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('putFeaturemaintenanceCategoryid', 'categoryId', categoryId)
            const localVarPath = `/FeatureMaintenance/{categoryId}`
                .replace('{categoryId}', encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsFeatureAddDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeatureMaintenanceApi - functional programming interface
 */
export const FeatureMaintenanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeatureMaintenanceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /FeatureMaintenance/{featureId} - DELETE
         * @param {string} featureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFeaturemaintenanceFeatureid(featureId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFeaturemaintenanceFeatureid(featureId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureMaintenanceApi.deleteFeaturemaintenanceFeatureid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /FeatureMaintenance/{product}/{customerId} - GET
         * @param {string} product 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeaturemaintenanceProductCustomerid(product: string, customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryMaintenanceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeaturemaintenanceProductCustomerid(product, customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureMaintenanceApi.getFeaturemaintenanceProductCustomerid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /FeatureMaintenance/products - GET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeaturemaintenanceProducts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMContractsProduct>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeaturemaintenanceProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureMaintenanceApi.getFeaturemaintenanceProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /FeatureMaintenance/templates/{product}/{customerId} - GET
         * @param {string} product 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeaturemaintenanceTemplatesProductCustomerid(product: string, customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMHMDCustomerManagementContractsV2FeaturesFeatureTemplateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeaturemaintenanceTemplatesProductCustomerid(product, customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureMaintenanceApi.getFeaturemaintenanceTemplatesProductCustomerid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /FeatureMaintenance/{featureId} - POST
         * @param {string} featureId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFeaturemaintenanceFeatureid(featureId: string, rHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFeaturemaintenanceFeatureid(featureId, rHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureMaintenanceApi.postFeaturemaintenanceFeatureid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /FeatureMaintenance/order/{product}/{customerId} - POST
         * @param {string} product 
         * @param {string} customerId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto} [rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFeaturemaintenanceOrderProductCustomerid(product: string, customerId: string, rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto?: RHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFeaturemaintenanceOrderProductCustomerid(product, customerId, rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureMaintenanceApi.postFeaturemaintenanceOrderProductCustomerid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /FeatureMaintenance/{categoryId} - PUT
         * @param {string} categoryId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsFeatureAddDto} [rHIMAPOCustomerManagementWebV2ModelsFeatureAddDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putFeaturemaintenanceCategoryid(categoryId: string, rHIMAPOCustomerManagementWebV2ModelsFeatureAddDto?: RHIMAPOCustomerManagementWebV2ModelsFeatureAddDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsFeatureMaintenanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putFeaturemaintenanceCategoryid(categoryId, rHIMAPOCustomerManagementWebV2ModelsFeatureAddDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureMaintenanceApi.putFeaturemaintenanceCategoryid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeatureMaintenanceApi - factory interface
 */
export const FeatureMaintenanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeatureMaintenanceApiFp(configuration)
    return {
        /**
         * 
         * @summary /FeatureMaintenance/{featureId} - DELETE
         * @param {string} featureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeaturemaintenanceFeatureid(featureId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteFeaturemaintenanceFeatureid(featureId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /FeatureMaintenance/{product}/{customerId} - GET
         * @param {string} product 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturemaintenanceProductCustomerid(product: string, customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOCustomerManagementWebV2ModelsFeatureCategoryMaintenanceDto>> {
            return localVarFp.getFeaturemaintenanceProductCustomerid(product, customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /FeatureMaintenance/products - GET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturemaintenanceProducts(options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMContractsProduct>> {
            return localVarFp.getFeaturemaintenanceProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /FeatureMaintenance/templates/{product}/{customerId} - GET
         * @param {string} product 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturemaintenanceTemplatesProductCustomerid(product: string, customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMHMDCustomerManagementContractsV2FeaturesFeatureTemplateDto>> {
            return localVarFp.getFeaturemaintenanceTemplatesProductCustomerid(product, customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /FeatureMaintenance/{featureId} - POST
         * @param {string} featureId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFeaturemaintenanceFeatureid(featureId: string, rHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postFeaturemaintenanceFeatureid(featureId, rHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /FeatureMaintenance/order/{product}/{customerId} - POST
         * @param {string} product 
         * @param {string} customerId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto} [rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFeaturemaintenanceOrderProductCustomerid(product: string, customerId: string, rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto?: RHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postFeaturemaintenanceOrderProductCustomerid(product, customerId, rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /FeatureMaintenance/{categoryId} - PUT
         * @param {string} categoryId 
         * @param {RHIMAPOCustomerManagementWebV2ModelsFeatureAddDto} [rHIMAPOCustomerManagementWebV2ModelsFeatureAddDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFeaturemaintenanceCategoryid(categoryId: string, rHIMAPOCustomerManagementWebV2ModelsFeatureAddDto?: RHIMAPOCustomerManagementWebV2ModelsFeatureAddDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsFeatureMaintenanceDto> {
            return localVarFp.putFeaturemaintenanceCategoryid(categoryId, rHIMAPOCustomerManagementWebV2ModelsFeatureAddDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeatureMaintenanceApi - object-oriented interface
 */
export class FeatureMaintenanceApi extends BaseAPI {
    /**
     * 
     * @summary /FeatureMaintenance/{featureId} - DELETE
     * @param {string} featureId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteFeaturemaintenanceFeatureid(featureId: string, options?: RawAxiosRequestConfig) {
        return FeatureMaintenanceApiFp(this.configuration).deleteFeaturemaintenanceFeatureid(featureId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /FeatureMaintenance/{product}/{customerId} - GET
     * @param {string} product 
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFeaturemaintenanceProductCustomerid(product: string, customerId: string, options?: RawAxiosRequestConfig) {
        return FeatureMaintenanceApiFp(this.configuration).getFeaturemaintenanceProductCustomerid(product, customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /FeatureMaintenance/products - GET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFeaturemaintenanceProducts(options?: RawAxiosRequestConfig) {
        return FeatureMaintenanceApiFp(this.configuration).getFeaturemaintenanceProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /FeatureMaintenance/templates/{product}/{customerId} - GET
     * @param {string} product 
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFeaturemaintenanceTemplatesProductCustomerid(product: string, customerId: string, options?: RawAxiosRequestConfig) {
        return FeatureMaintenanceApiFp(this.configuration).getFeaturemaintenanceTemplatesProductCustomerid(product, customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /FeatureMaintenance/{featureId} - POST
     * @param {string} featureId 
     * @param {RHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postFeaturemaintenanceFeatureid(featureId: string, rHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto, options?: RawAxiosRequestConfig) {
        return FeatureMaintenanceApiFp(this.configuration).postFeaturemaintenanceFeatureid(featureId, rHIMAPOCustomerManagementWebV2ModelsFeatureUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /FeatureMaintenance/order/{product}/{customerId} - POST
     * @param {string} product 
     * @param {string} customerId 
     * @param {RHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto} [rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postFeaturemaintenanceOrderProductCustomerid(product: string, customerId: string, rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto?: RHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto, options?: RawAxiosRequestConfig) {
        return FeatureMaintenanceApiFp(this.configuration).postFeaturemaintenanceOrderProductCustomerid(product, customerId, rHIMAPOCustomerManagementWebV2ModelsItemsPositionsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /FeatureMaintenance/{categoryId} - PUT
     * @param {string} categoryId 
     * @param {RHIMAPOCustomerManagementWebV2ModelsFeatureAddDto} [rHIMAPOCustomerManagementWebV2ModelsFeatureAddDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putFeaturemaintenanceCategoryid(categoryId: string, rHIMAPOCustomerManagementWebV2ModelsFeatureAddDto?: RHIMAPOCustomerManagementWebV2ModelsFeatureAddDto, options?: RawAxiosRequestConfig) {
        return FeatureMaintenanceApiFp(this.configuration).putFeaturemaintenanceCategoryid(categoryId, rHIMAPOCustomerManagementWebV2ModelsFeatureAddDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HmdFeaturesApi - axios parameter creator
 */
export const HmdFeaturesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all Hmd features that can be assigned to a customer.
         * @summary Get all Hmd features that can be assigned to a customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatures: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Hmd features that can be assigned to a customer.
         * @summary Get all Hmd features that can be assigned to a customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHmdfeatures: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/HmdFeatures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HmdFeaturesApi - functional programming interface
 */
export const HmdFeaturesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HmdFeaturesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all Hmd features that can be assigned to a customer.
         * @summary Get all Hmd features that can be assigned to a customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatures(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMContractsHmdFeature>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatures(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HmdFeaturesApi.getFeatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Hmd features that can be assigned to a customer.
         * @summary Get all Hmd features that can be assigned to a customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHmdfeatures(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMContractsHmdFeature>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHmdfeatures(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HmdFeaturesApi.getHmdfeatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HmdFeaturesApi - factory interface
 */
export const HmdFeaturesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HmdFeaturesApiFp(configuration)
    return {
        /**
         * Get all Hmd features that can be assigned to a customer.
         * @summary Get all Hmd features that can be assigned to a customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatures(options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMContractsHmdFeature>> {
            return localVarFp.getFeatures(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Hmd features that can be assigned to a customer.
         * @summary Get all Hmd features that can be assigned to a customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHmdfeatures(options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMContractsHmdFeature>> {
            return localVarFp.getHmdfeatures(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HmdFeaturesApi - object-oriented interface
 */
export class HmdFeaturesApi extends BaseAPI {
    /**
     * Get all Hmd features that can be assigned to a customer.
     * @summary Get all Hmd features that can be assigned to a customer.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFeatures(options?: RawAxiosRequestConfig) {
        return HmdFeaturesApiFp(this.configuration).getFeatures(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Hmd features that can be assigned to a customer.
     * @summary Get all Hmd features that can be assigned to a customer.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getHmdfeatures(options?: RawAxiosRequestConfig) {
        return HmdFeaturesApiFp(this.configuration).getHmdfeatures(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RolesApi - axios parameter creator
 */
export const RolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all customer and global APO roles.
         * @summary Get all customer and global APO roles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RolesApi - functional programming interface
 */
export const RolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RolesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all customer and global APO roles.
         * @summary Get all customer and global APO roles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsRolesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.getRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RolesApi - factory interface
 */
export const RolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RolesApiFp(configuration)
    return {
        /**
         * Get all customer and global APO roles.
         * @summary Get all customer and global APO roles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles(options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsRolesDto> {
            return localVarFp.getRoles(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RolesApi - object-oriented interface
 */
export class RolesApi extends BaseAPI {
    /**
     * Get all customer and global APO roles.
     * @summary Get all customer and global APO roles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRoles(options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).getRoles(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserInfoApi - axios parameter creator
 */
export const UserInfoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves information about the logged-in user.
         * @summary Retrieves information about the logged-in user.
         * @param {string} [xRHIMApoId] The userId in Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserinfoMe: async (xRHIMApoId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserInfo/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xRHIMApoId != null) {
                localVarHeaderParameter['X-RHIM-ApoId'] = String(xRHIMApoId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserInfoApi - functional programming interface
 */
export const UserInfoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserInfoApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves information about the logged-in user.
         * @summary Retrieves information about the logged-in user.
         * @param {string} [xRHIMApoId] The userId in Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserinfoMe(xRHIMApoId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMHMDCustomerManagementContractsV2UserUserInfoResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserinfoMe(xRHIMApoId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserInfoApi.getUserinfoMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserInfoApi - factory interface
 */
export const UserInfoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserInfoApiFp(configuration)
    return {
        /**
         * Retrieves information about the logged-in user.
         * @summary Retrieves information about the logged-in user.
         * @param {string} [xRHIMApoId] The userId in Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserinfoMe(xRHIMApoId?: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMHMDCustomerManagementContractsV2UserUserInfoResponseDto> {
            return localVarFp.getUserinfoMe(xRHIMApoId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserInfoApi - object-oriented interface
 */
export class UserInfoApi extends BaseAPI {
    /**
     * Retrieves information about the logged-in user.
     * @summary Retrieves information about the logged-in user.
     * @param {string} [xRHIMApoId] The userId in Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserinfoMe(xRHIMApoId?: string, options?: RawAxiosRequestConfig) {
        return UserInfoApiFp(this.configuration).getUserinfoMe(xRHIMApoId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserResolverApi - axios parameter creator
 */
export const UserResolverApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /UserResolver/short/all - POST
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserresolverShortAll: async (requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UserResolver/short/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserResolverApi - functional programming interface
 */
export const UserResolverApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserResolverApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /UserResolver/short/all - POST
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUserresolverShortAll(requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: RHIMAPOCustomerManagementWebV2ModelsUserShortInfoDto; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUserresolverShortAll(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserResolverApi.postUserresolverShortAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserResolverApi - factory interface
 */
export const UserResolverApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserResolverApiFp(configuration)
    return {
        /**
         * 
         * @summary /UserResolver/short/all - POST
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserresolverShortAll(requestBody?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: RHIMAPOCustomerManagementWebV2ModelsUserShortInfoDto; }> {
            return localVarFp.postUserresolverShortAll(requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserResolverApi - object-oriented interface
 */
export class UserResolverApi extends BaseAPI {
    /**
     * 
     * @summary /UserResolver/short/all - POST
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postUserresolverShortAll(requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return UserResolverApiFp(this.configuration).postUserresolverShortAll(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersApi - axios parameter creator
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete user
         * @summary Delete user
         * @param {string} userId User id to identify the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsersUserid: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUsersUserid', 'userId', userId)
            const localVarPath = `/Users/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the user UI settings
         * @summary Deletes the user UI settings
         * @param {string} [xRHIMApoId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsersUsersettings: async (xRHIMApoId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Users/usersettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            if (xRHIMApoId != null) {
                localVarHeaderParameter['X-RHIM-ApoId'] = String(xRHIMApoId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get users
         * @summary Get users
         * @param {string} [customerId] Optional filter to get users only for specific customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (customerId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user
         * @summary Get user
         * @param {string} userId User id to identify the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersUserid: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUsersUserid', 'userId', userId)
            const localVarPath = `/Users/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user invitation uri
         * @summary Get user invitation uri
         * @param {string} userId User id to identify the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersUseridInvitationuri: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUsersUseridInvitationuri', 'userId', userId)
            const localVarPath = `/Users/{userId}/invitationuri`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user roles
         * @summary Get user roles
         * @param {string} userId User id to identify the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersUseridRoles: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUsersUseridRoles', 'userId', userId)
            const localVarPath = `/Users/{userId}/roles`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the user UI settings
         * @summary Retrieves the user UI settings
         * @param {string} [xRHIMApoId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersUsersettings: async (xRHIMApoId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Users/usersettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            if (xRHIMApoId != null) {
                localVarHeaderParameter['X-RHIM-ApoId'] = String(xRHIMApoId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create the new user
         * @summary Create the new user
         * @param {RHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto] The user data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUsers: async (rHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * resend invitation email to user
         * @summary resend invitation email to user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUsersUseridSendinvitation: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('postUsersUseridSendinvitation', 'userId', userId)
            const localVarPath = `/Users/{userId}/sendinvitation`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user
         * @summary Update user
         * @param {string} userId User id to identify the user
         * @param {RHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto] The user data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUsersUserid: async (userId: string, rHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('putUsersUserid', 'userId', userId)
            const localVarPath = `/Users/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user\'s global and customer role
         * @summary Update user\'s global and customer role
         * @param {string} userId User id to identify the user
         * @param {RHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto} [rHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto] User\&#39;s global and customer role data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUsersUseridRoles: async (userId: string, rHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto?: RHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('putUsersUseridRoles', 'userId', userId)
            const localVarPath = `/Users/{userId}/roles`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upserts the usersettings
         * @summary Upserts the usersettings
         * @param {string} [xRHIMApoId] 
         * @param {RHIMAPOCustomerManagementWebV2ModelsUserSettingsDto} [rHIMAPOCustomerManagementWebV2ModelsUserSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUsersUsersettings: async (xRHIMApoId?: string, rHIMAPOCustomerManagementWebV2ModelsUserSettingsDto?: RHIMAPOCustomerManagementWebV2ModelsUserSettingsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Users/usersettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (xRHIMApoId != null) {
                localVarHeaderParameter['X-RHIM-ApoId'] = String(xRHIMApoId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsUserSettingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete user
         * @summary Delete user
         * @param {string} userId User id to identify the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUsersUserid(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUsersUserid(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.deleteUsersUserid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes the user UI settings
         * @summary Deletes the user UI settings
         * @param {string} [xRHIMApoId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUsersUsersettings(xRHIMApoId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUsersUsersettings(xRHIMApoId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.deleteUsersUsersettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get users
         * @summary Get users
         * @param {string} [customerId] Optional filter to get users only for specific customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(customerId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOCustomerManagementWebV2ModelsUserDetailDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get user
         * @summary Get user
         * @param {string} userId User id to identify the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersUserid(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsUserDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersUserid(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUsersUserid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get user invitation uri
         * @summary Get user invitation uri
         * @param {string} userId User id to identify the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersUseridInvitationuri(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersUseridInvitationuri(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUsersUseridInvitationuri']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get user roles
         * @summary Get user roles
         * @param {string} userId User id to identify the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersUseridRoles(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsUserRolesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersUseridRoles(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUsersUseridRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the user UI settings
         * @summary Retrieves the user UI settings
         * @param {string} [xRHIMApoId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersUsersettings(xRHIMApoId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsUserSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersUsersettings(xRHIMApoId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUsersUsersettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create the new user
         * @summary Create the new user
         * @param {RHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto] The user data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUsers(rHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUsers(rHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.postUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * resend invitation email to user
         * @summary resend invitation email to user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUsersUseridSendinvitation(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUsersUseridSendinvitation(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.postUsersUseridSendinvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user
         * @summary Update user
         * @param {string} userId User id to identify the user
         * @param {RHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto] The user data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putUsersUserid(userId: string, rHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putUsersUserid(userId, rHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.putUsersUserid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user\'s global and customer role
         * @summary Update user\'s global and customer role
         * @param {string} userId User id to identify the user
         * @param {RHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto} [rHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto] User\&#39;s global and customer role data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putUsersUseridRoles(userId: string, rHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto?: RHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putUsersUseridRoles(userId, rHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.putUsersUseridRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upserts the usersettings
         * @summary Upserts the usersettings
         * @param {string} [xRHIMApoId] 
         * @param {RHIMAPOCustomerManagementWebV2ModelsUserSettingsDto} [rHIMAPOCustomerManagementWebV2ModelsUserSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putUsersUsersettings(xRHIMApoId?: string, rHIMAPOCustomerManagementWebV2ModelsUserSettingsDto?: RHIMAPOCustomerManagementWebV2ModelsUserSettingsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putUsersUsersettings(xRHIMApoId, rHIMAPOCustomerManagementWebV2ModelsUserSettingsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.putUsersUsersettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * Delete user
         * @summary Delete user
         * @param {string} userId User id to identify the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsersUserid(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUsersUserid(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the user UI settings
         * @summary Deletes the user UI settings
         * @param {string} [xRHIMApoId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsersUsersettings(xRHIMApoId?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUsersUsersettings(xRHIMApoId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get users
         * @summary Get users
         * @param {string} [customerId] Optional filter to get users only for specific customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(customerId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOCustomerManagementWebV2ModelsUserDetailDto>> {
            return localVarFp.getUsers(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get user
         * @summary Get user
         * @param {string} userId User id to identify the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersUserid(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsUserDetailDto> {
            return localVarFp.getUsersUserid(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get user invitation uri
         * @summary Get user invitation uri
         * @param {string} userId User id to identify the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersUseridInvitationuri(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getUsersUseridInvitationuri(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get user roles
         * @summary Get user roles
         * @param {string} userId User id to identify the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersUseridRoles(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsUserRolesDto> {
            return localVarFp.getUsersUseridRoles(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the user UI settings
         * @summary Retrieves the user UI settings
         * @param {string} [xRHIMApoId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersUsersettings(xRHIMApoId?: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsUserSettingsDto> {
            return localVarFp.getUsersUsersettings(xRHIMApoId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create the new user
         * @summary Create the new user
         * @param {RHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto] The user data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUsers(rHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsUserDto> {
            return localVarFp.postUsers(rHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * resend invitation email to user
         * @summary resend invitation email to user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUsersUseridSendinvitation(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postUsersUseridSendinvitation(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update user
         * @summary Update user
         * @param {string} userId User id to identify the user
         * @param {RHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto] The user data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUsersUserid(userId: string, rHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putUsersUserid(userId, rHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update user\'s global and customer role
         * @summary Update user\'s global and customer role
         * @param {string} userId User id to identify the user
         * @param {RHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto} [rHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto] User\&#39;s global and customer role data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUsersUseridRoles(userId: string, rHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto?: RHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putUsersUseridRoles(userId, rHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Upserts the usersettings
         * @summary Upserts the usersettings
         * @param {string} [xRHIMApoId] 
         * @param {RHIMAPOCustomerManagementWebV2ModelsUserSettingsDto} [rHIMAPOCustomerManagementWebV2ModelsUserSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUsersUsersettings(xRHIMApoId?: string, rHIMAPOCustomerManagementWebV2ModelsUserSettingsDto?: RHIMAPOCustomerManagementWebV2ModelsUserSettingsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putUsersUsersettings(xRHIMApoId, rHIMAPOCustomerManagementWebV2ModelsUserSettingsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 */
export class UsersApi extends BaseAPI {
    /**
     * Delete user
     * @summary Delete user
     * @param {string} userId User id to identify the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteUsersUserid(userId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).deleteUsersUserid(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the user UI settings
     * @summary Deletes the user UI settings
     * @param {string} [xRHIMApoId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteUsersUsersettings(xRHIMApoId?: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).deleteUsersUsersettings(xRHIMApoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get users
     * @summary Get users
     * @param {string} [customerId] Optional filter to get users only for specific customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUsers(customerId?: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUsers(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user
     * @summary Get user
     * @param {string} userId User id to identify the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUsersUserid(userId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUsersUserid(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user invitation uri
     * @summary Get user invitation uri
     * @param {string} userId User id to identify the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUsersUseridInvitationuri(userId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUsersUseridInvitationuri(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user roles
     * @summary Get user roles
     * @param {string} userId User id to identify the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUsersUseridRoles(userId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUsersUseridRoles(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the user UI settings
     * @summary Retrieves the user UI settings
     * @param {string} [xRHIMApoId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUsersUsersettings(xRHIMApoId?: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUsersUsersettings(xRHIMApoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create the new user
     * @summary Create the new user
     * @param {RHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto] The user data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postUsers(rHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).postUsers(rHIMAPOCustomerManagementWebV2ModelsUserCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * resend invitation email to user
     * @summary resend invitation email to user
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postUsersUseridSendinvitation(userId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).postUsersUseridSendinvitation(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user
     * @summary Update user
     * @param {string} userId User id to identify the user
     * @param {RHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto] The user data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putUsersUserid(userId: string, rHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).putUsersUserid(userId, rHIMAPOCustomerManagementWebV2ModelsUserUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user\'s global and customer role
     * @summary Update user\'s global and customer role
     * @param {string} userId User id to identify the user
     * @param {RHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto} [rHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto] User\&#39;s global and customer role data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putUsersUseridRoles(userId: string, rHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto?: RHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).putUsersUseridRoles(userId, rHIMAPOCustomerManagementWebV2ModelsUserUpdateRolesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upserts the usersettings
     * @summary Upserts the usersettings
     * @param {string} [xRHIMApoId] 
     * @param {RHIMAPOCustomerManagementWebV2ModelsUserSettingsDto} [rHIMAPOCustomerManagementWebV2ModelsUserSettingsDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putUsersUsersettings(xRHIMApoId?: string, rHIMAPOCustomerManagementWebV2ModelsUserSettingsDto?: RHIMAPOCustomerManagementWebV2ModelsUserSettingsDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).putUsersUsersettings(xRHIMApoId, rHIMAPOCustomerManagementWebV2ModelsUserSettingsDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VesselPropertiesApi - axios parameter creator
 */
export const VesselPropertiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/anf
         * @summary Retrieves the properties for the Anode furnace vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidAnf: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidAnf', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/anf`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/aod
         * @summary Retrieves properties of the AOD vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidAod: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidAod', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/aod`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/bfr
         * @summary Retrieves properties of the BFR vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidBfr: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidBfr', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/bfr`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/bof
         * @summary Retrieves the BOF properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidBof: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidBof', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/bof`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/cca
         * @summary Retrieves the properties for Cement Calciner vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidCca: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidCca', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/cca`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/cco
         * @summary Retrieves the properties for Cement Cooler vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidCco: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidCco', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/cco`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/ccy
         * @summary Retrieves the properties for Cement Cyclone vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidCcy: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidCcy', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/ccy`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/cou
         * @summary Retrieves properties of a Coke Oven
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidCou: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidCou', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/cou`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/crk
         * @summary Retrieves the CRK properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidCrk: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidCrk', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/crk`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/eaf
         * @summary Retrieves the EAF properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidEaf: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidEaf', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/eaf`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/ladle
         * @summary Retrieves the properties for Hot Metal Ladle vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidHml: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidHml', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/hml`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/hof
         * @summary Retrieves the properties for the Holding furnace vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidHof: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidHof', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/hof`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/ladle
         * @summary Retrieves the Ladle properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidLadle: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidLadle', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/ladle`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/maf
         * @summary Retrieves the properties for the MAERZ furnace vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidMaf: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidMaf', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/maf`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/pcg
         * @summary Retrieves the properties for the Petcoke gassifier vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidPcg: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidPcg', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/pcg`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/rh
         * @summary Retrieves the RH properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidRh: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidRh', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/rh`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/rhl
         * @summary Retrieves the RHL properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidRhl: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidRhl', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/rhl`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/shf
         * @summary Retrieves the properties for the Shaft furnace vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidShf: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidShf', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/shf`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/srf
         * @summary Retrieves properties of a SRF vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidSrf: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidSrf', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/srf`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/tif
         * @summary Retrieves the properties for the Tilting furnace vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidTif: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidTif', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/tif`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/tun
         * @summary Retrieves the properties for the tundish vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidTun: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidTun', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/tun`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/anf
         * @summary Updates the properties for an Anode furnace vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidAnf: async (vesselId: string, body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidAnf', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/anf`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/aod
         * @summary Updates the properties of the AOD vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidAod: async (vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidAod', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/aod`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/bfr
         * @summary Updates the properties of the BFR vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidBfr: async (vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidBfr', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/bfr`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/bof
         * @summary Updates the BOF properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidBof: async (vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidBof', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/bof`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/cca
         * @summary Updates the properties for a Cement Cooler vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidCca: async (vesselId: string, body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidCca', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/cca`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/cco
         * @summary Updates the properties for a Cement Cooler vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidCco: async (vesselId: string, body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidCco', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/cco`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/ccy
         * @summary Updates the properties for a Cement Cyclone vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidCcy: async (vesselId: string, body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidCcy', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/ccy`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/cou
         * @summary Updates the properties of a Coke Oven
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidCou: async (vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidCou', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/cou`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/crk
         * @summary Updates the CRK properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidCrk: async (vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidCrk', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/crk`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/eaf
         * @summary Updates the EAF properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidEaf: async (vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidEaf', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/eaf`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/ladle
         * @summary Updates the properties for a Hot Metal Ladle vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidHml: async (vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidHml', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/hml`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/hof
         * @summary Updates the properties for a Holding furnace vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidHof: async (vesselId: string, body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidHof', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/hof`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/ladle
         * @summary Updates the Ladle properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidLadle: async (vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidLadle', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/ladle`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/maf
         * @summary Updates the properties for a MAERZ furnace vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidMaf: async (vesselId: string, body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidMaf', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/maf`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/pcg
         * @summary Updates the properties for a Petcoke gassifier vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidPcg: async (vesselId: string, body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidPcg', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/pcg`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/rh
         * @summary Updates the RH properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidRh: async (vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidRh', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/rh`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/rhl
         * @summary Updates the RHL properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidRhl: async (vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidRhl', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/rhl`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/shf
         * @summary Updates the properties for a Shaft furnace vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidShf: async (vesselId: string, body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidShf', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/shf`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/srf
         * @summary Updates the properties of a SRF vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidSrf: async (vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidSrf', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/srf`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/tif
         * @summary Updates the properties for a Tilting furnace vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidTif: async (vesselId: string, body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidTif', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/tif`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/tun
         * @summary Updates the properties for a the tundish vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidTun: async (vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidTun', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/tun`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VesselPropertiesApi - functional programming interface
 */
export const VesselPropertiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VesselPropertiesApiAxiosParamCreator(configuration)
    return {
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/anf
         * @summary Retrieves the properties for the Anode furnace vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidAnf(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidAnf(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidAnf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/aod
         * @summary Retrieves properties of the AOD vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidAod(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidAod(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidAod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/bfr
         * @summary Retrieves properties of the BFR vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidBfr(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidBfr(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidBfr']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/bof
         * @summary Retrieves the BOF properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidBof(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidBof(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidBof']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/cca
         * @summary Retrieves the properties for Cement Calciner vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidCca(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidCca(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidCca']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/cco
         * @summary Retrieves the properties for Cement Cooler vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidCco(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidCco(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidCco']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/ccy
         * @summary Retrieves the properties for Cement Cyclone vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidCcy(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidCcy(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidCcy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/cou
         * @summary Retrieves properties of a Coke Oven
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidCou(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidCou(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidCou']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/crk
         * @summary Retrieves the CRK properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidCrk(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidCrk(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidCrk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/eaf
         * @summary Retrieves the EAF properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidEaf(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidEaf(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidEaf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/ladle
         * @summary Retrieves the properties for Hot Metal Ladle vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidHml(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidHml(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidHml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/hof
         * @summary Retrieves the properties for the Holding furnace vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidHof(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidHof(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidHof']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/ladle
         * @summary Retrieves the Ladle properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidLadle(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidLadle(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidLadle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/maf
         * @summary Retrieves the properties for the MAERZ furnace vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidMaf(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidMaf(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidMaf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/pcg
         * @summary Retrieves the properties for the Petcoke gassifier vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidPcg(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidPcg(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidPcg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/rh
         * @summary Retrieves the RH properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidRh(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidRh(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidRh']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/rhl
         * @summary Retrieves the RHL properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidRhl(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidRhl(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidRhl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/shf
         * @summary Retrieves the properties for the Shaft furnace vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidShf(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidShf(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidShf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/srf
         * @summary Retrieves properties of a SRF vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidSrf(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidSrf(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidSrf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/tif
         * @summary Retrieves the properties for the Tilting furnace vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidTif(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidTif(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidTif']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/tun
         * @summary Retrieves the properties for the tundish vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidTun(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidTun(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.getVesselsVesselidTun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/anf
         * @summary Updates the properties for an Anode furnace vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidAnf(vesselId: string, body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidAnf(vesselId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidAnf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/aod
         * @summary Updates the properties of the AOD vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidAod(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidAod(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidAod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/bfr
         * @summary Updates the properties of the BFR vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidBfr(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidBfr(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidBfr']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/bof
         * @summary Updates the BOF properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidBof(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidBof(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidBof']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/cca
         * @summary Updates the properties for a Cement Cooler vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidCca(vesselId: string, body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidCca(vesselId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidCca']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/cco
         * @summary Updates the properties for a Cement Cooler vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidCco(vesselId: string, body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidCco(vesselId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidCco']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/ccy
         * @summary Updates the properties for a Cement Cyclone vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidCcy(vesselId: string, body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidCcy(vesselId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidCcy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/cou
         * @summary Updates the properties of a Coke Oven
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidCou(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidCou(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidCou']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/crk
         * @summary Updates the CRK properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidCrk(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidCrk(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidCrk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/eaf
         * @summary Updates the EAF properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidEaf(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidEaf(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidEaf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/ladle
         * @summary Updates the properties for a Hot Metal Ladle vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidHml(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidHml(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidHml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/hof
         * @summary Updates the properties for a Holding furnace vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidHof(vesselId: string, body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidHof(vesselId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidHof']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/ladle
         * @summary Updates the Ladle properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidLadle(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidLadle(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidLadle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/maf
         * @summary Updates the properties for a MAERZ furnace vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidMaf(vesselId: string, body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidMaf(vesselId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidMaf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/pcg
         * @summary Updates the properties for a Petcoke gassifier vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidPcg(vesselId: string, body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidPcg(vesselId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidPcg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/rh
         * @summary Updates the RH properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidRh(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidRh(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidRh']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/rhl
         * @summary Updates the RHL properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidRhl(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidRhl(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidRhl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/shf
         * @summary Updates the properties for a Shaft furnace vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidShf(vesselId: string, body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidShf(vesselId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidShf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/srf
         * @summary Updates the properties of a SRF vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidSrf(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidSrf(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidSrf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/tif
         * @summary Updates the properties for a Tilting furnace vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidTif(vesselId: string, body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidTif(vesselId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidTif']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/tun
         * @summary Updates the properties for a the tundish vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidTun(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidTun(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselPropertiesApi.putVesselsVesselidTun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VesselPropertiesApi - factory interface
 */
export const VesselPropertiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VesselPropertiesApiFp(configuration)
    return {
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/anf
         * @summary Retrieves the properties for the Anode furnace vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidAnf(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getVesselsVesselidAnf(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/aod
         * @summary Retrieves properties of the AOD vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidAod(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto> {
            return localVarFp.getVesselsVesselidAod(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/bfr
         * @summary Retrieves properties of the BFR vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidBfr(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto> {
            return localVarFp.getVesselsVesselidBfr(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/bof
         * @summary Retrieves the BOF properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidBof(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto> {
            return localVarFp.getVesselsVesselidBof(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/cca
         * @summary Retrieves the properties for Cement Calciner vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidCca(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getVesselsVesselidCca(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/cco
         * @summary Retrieves the properties for Cement Cooler vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidCco(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getVesselsVesselidCco(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/ccy
         * @summary Retrieves the properties for Cement Cyclone vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidCcy(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getVesselsVesselidCcy(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/cou
         * @summary Retrieves properties of a Coke Oven
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidCou(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto> {
            return localVarFp.getVesselsVesselidCou(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/crk
         * @summary Retrieves the CRK properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidCrk(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesDto> {
            return localVarFp.getVesselsVesselidCrk(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/eaf
         * @summary Retrieves the EAF properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidEaf(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto> {
            return localVarFp.getVesselsVesselidEaf(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/ladle
         * @summary Retrieves the properties for Hot Metal Ladle vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidHml(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto> {
            return localVarFp.getVesselsVesselidHml(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/hof
         * @summary Retrieves the properties for the Holding furnace vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidHof(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getVesselsVesselidHof(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/ladle
         * @summary Retrieves the Ladle properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidLadle(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto> {
            return localVarFp.getVesselsVesselidLadle(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/maf
         * @summary Retrieves the properties for the MAERZ furnace vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidMaf(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getVesselsVesselidMaf(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/pcg
         * @summary Retrieves the properties for the Petcoke gassifier vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidPcg(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getVesselsVesselidPcg(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/rh
         * @summary Retrieves the RH properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidRh(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto> {
            return localVarFp.getVesselsVesselidRh(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/rhl
         * @summary Retrieves the RHL properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidRhl(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto> {
            return localVarFp.getVesselsVesselidRhl(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/shf
         * @summary Retrieves the properties for the Shaft furnace vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidShf(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getVesselsVesselidShf(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/srf
         * @summary Retrieves properties of a SRF vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidSrf(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto> {
            return localVarFp.getVesselsVesselidSrf(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/tif
         * @summary Retrieves the properties for the Tilting furnace vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidTif(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getVesselsVesselidTif(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/tun
         * @summary Retrieves the properties for the tundish vessel.
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidTun(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto> {
            return localVarFp.getVesselsVesselidTun(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/anf
         * @summary Updates the properties for an Anode furnace vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidAnf(vesselId: string, body?: object, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidAnf(vesselId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/aod
         * @summary Updates the properties of the AOD vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidAod(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidAod(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/bfr
         * @summary Updates the properties of the BFR vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidBfr(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidBfr(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/bof
         * @summary Updates the BOF properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidBof(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidBof(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/cca
         * @summary Updates the properties for a Cement Cooler vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidCca(vesselId: string, body?: object, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidCca(vesselId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/cco
         * @summary Updates the properties for a Cement Cooler vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidCco(vesselId: string, body?: object, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidCco(vesselId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/ccy
         * @summary Updates the properties for a Cement Cyclone vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidCcy(vesselId: string, body?: object, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidCcy(vesselId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/cou
         * @summary Updates the properties of a Coke Oven
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidCou(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidCou(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/crk
         * @summary Updates the CRK properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidCrk(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidCrk(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/eaf
         * @summary Updates the EAF properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidEaf(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidEaf(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/ladle
         * @summary Updates the properties for a Hot Metal Ladle vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidHml(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidHml(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/hof
         * @summary Updates the properties for a Holding furnace vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidHof(vesselId: string, body?: object, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidHof(vesselId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/ladle
         * @summary Updates the Ladle properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidLadle(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidLadle(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/maf
         * @summary Updates the properties for a MAERZ furnace vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidMaf(vesselId: string, body?: object, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidMaf(vesselId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/pcg
         * @summary Updates the properties for a Petcoke gassifier vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidPcg(vesselId: string, body?: object, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidPcg(vesselId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/rh
         * @summary Updates the RH properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidRh(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidRh(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/rhl
         * @summary Updates the RHL properties of a vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidRhl(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidRhl(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/shf
         * @summary Updates the properties for a Shaft furnace vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidShf(vesselId: string, body?: object, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidShf(vesselId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/srf
         * @summary Updates the properties of a SRF vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidSrf(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidSrf(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/tif
         * @summary Updates the properties for a Tilting furnace vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {object} [body] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidTif(vesselId: string, body?: object, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidTif(vesselId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/tun
         * @summary Updates the properties for a the tundish vessel
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto] The properties to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidTun(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidTun(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VesselPropertiesApi - object-oriented interface
 */
export class VesselPropertiesApi extends BaseAPI {
    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/anf
     * @summary Retrieves the properties for the Anode furnace vessel.
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidAnf(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidAnf(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/aod
     * @summary Retrieves properties of the AOD vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidAod(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidAod(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/bfr
     * @summary Retrieves properties of the BFR vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidBfr(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidBfr(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/bof
     * @summary Retrieves the BOF properties of a vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidBof(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidBof(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/cca
     * @summary Retrieves the properties for Cement Calciner vessel.
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidCca(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidCca(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/cco
     * @summary Retrieves the properties for Cement Cooler vessel.
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidCco(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidCco(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/ccy
     * @summary Retrieves the properties for Cement Cyclone vessel.
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidCcy(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidCcy(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/cou
     * @summary Retrieves properties of a Coke Oven
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidCou(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidCou(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/crk
     * @summary Retrieves the CRK properties of a vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidCrk(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidCrk(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/eaf
     * @summary Retrieves the EAF properties of a vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidEaf(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidEaf(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/ladle
     * @summary Retrieves the properties for Hot Metal Ladle vessel.
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidHml(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidHml(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/hof
     * @summary Retrieves the properties for the Holding furnace vessel.
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidHof(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidHof(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/ladle
     * @summary Retrieves the Ladle properties of a vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidLadle(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidLadle(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/maf
     * @summary Retrieves the properties for the MAERZ furnace vessel.
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidMaf(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidMaf(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/pcg
     * @summary Retrieves the properties for the Petcoke gassifier vessel.
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidPcg(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidPcg(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/rh
     * @summary Retrieves the RH properties of a vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidRh(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidRh(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/rhl
     * @summary Retrieves the RHL properties of a vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidRhl(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidRhl(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/shf
     * @summary Retrieves the properties for the Shaft furnace vessel.
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidShf(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidShf(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/srf
     * @summary Retrieves properties of a SRF vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidSrf(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidSrf(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/tif
     * @summary Retrieves the properties for the Tilting furnace vessel.
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidTif(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidTif(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000/tun
     * @summary Retrieves the properties for the tundish vessel.
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidTun(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).getVesselsVesselidTun(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/anf
     * @summary Updates the properties for an Anode furnace vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {object} [body] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidAnf(vesselId: string, body?: object, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidAnf(vesselId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/aod
     * @summary Updates the properties of the AOD vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidAod(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidAod(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesAodVesselPropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/bfr
     * @summary Updates the properties of the BFR vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidBfr(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidBfr(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBfrVesselPropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/bof
     * @summary Updates the BOF properties of a vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidBof(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidBof(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesBofVesselPropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/cca
     * @summary Updates the properties for a Cement Cooler vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {object} [body] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidCca(vesselId: string, body?: object, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidCca(vesselId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/cco
     * @summary Updates the properties for a Cement Cooler vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {object} [body] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidCco(vesselId: string, body?: object, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidCco(vesselId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/ccy
     * @summary Updates the properties for a Cement Cyclone vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {object} [body] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidCcy(vesselId: string, body?: object, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidCcy(vesselId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/cou
     * @summary Updates the properties of a Coke Oven
     * @param {string} vesselId Identifier of the vessel
     * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidCou(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidCou(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCouVesselPropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/crk
     * @summary Updates the CRK properties of a vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidCrk(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidCrk(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesCrkVesselPropertiesUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/eaf
     * @summary Updates the EAF properties of a vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidEaf(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidEaf(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesEafVesselPropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/ladle
     * @summary Updates the properties for a Hot Metal Ladle vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidHml(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidHml(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesHmlVesselPropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/hof
     * @summary Updates the properties for a Holding furnace vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {object} [body] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidHof(vesselId: string, body?: object, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidHof(vesselId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/ladle
     * @summary Updates the Ladle properties of a vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidLadle(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidLadle(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesLadleVesselPropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/maf
     * @summary Updates the properties for a MAERZ furnace vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {object} [body] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidMaf(vesselId: string, body?: object, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidMaf(vesselId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/pcg
     * @summary Updates the properties for a Petcoke gassifier vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {object} [body] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidPcg(vesselId: string, body?: object, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidPcg(vesselId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/rh
     * @summary Updates the RH properties of a vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidRh(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidRh(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhVesselPropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/rhl
     * @summary Updates the RHL properties of a vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidRhl(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidRhl(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesRhlVesselPropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/shf
     * @summary Updates the properties for a Shaft furnace vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {object} [body] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidShf(vesselId: string, body?: object, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidShf(vesselId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/srf
     * @summary Updates the properties of a SRF vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidSrf(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidSrf(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesSrfVesselPropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/tif
     * @summary Updates the properties for a Tilting furnace vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {object} [body] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidTif(vesselId: string, body?: object, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidTif(vesselId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                Put /vessels/00000000-0000-0000-0004-100000000000/tun
     * @summary Updates the properties for a the tundish vessel
     * @param {string} vesselId Identifier of the vessel
     * @param {RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto} [rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto] The properties to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidTun(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto?: RHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto, options?: RawAxiosRequestConfig) {
        return VesselPropertiesApiFp(this.configuration).putVesselsVesselidTun(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselPropertiesTunVesselPropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VesselTemplatesApi - axios parameter creator
 */
export const VesselTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the vessel template for the given vessel type kilns
         * @summary Returns the vessel template for the given vessel type kilns
         * @param {string} [vesselType] The vessel type for which a template should be downloaded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesseltemplatesDownload: async (vesselType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/VesselTemplates/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vesselType !== undefined) {
                localVarQueryParameter['vesselType'] = vesselType;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the all vessel type for which a template exists
         * @summary Returns the all vessel type for which a template exists
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesseltemplatesVesseltypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/VesselTemplates/vesseltypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new vessel based on the provided excel template
         * @summary Create a new vessel based on the provided excel template
         * @param {string} customerId Identifier of the customer
         * @param {string} [contentType] 
         * @param {string} [contentDisposition] 
         * @param {object} [headers] 
         * @param {number} [length] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCustomerCustomeridVesseltemplatesUpload: async (customerId: string, contentType?: string, contentDisposition?: string, headers?: object, length?: number, name?: string, fileName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('postCustomerCustomeridVesseltemplatesUpload', 'customerId', customerId)
            const localVarPath = `/customer/{customerId}/vesseltemplates/upload`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (contentType !== undefined) { 
                localVarFormParams.append('ContentType', contentType as any);
            }

            if (contentDisposition !== undefined) { 
                localVarFormParams.append('ContentDisposition', contentDisposition as any);
            }

            if (headers !== undefined) { 
                localVarFormParams.append('Headers', new Blob([JSON.stringify(headers, replaceWithSerializableTypeIfNeeded)], { type: "application/json", }));
            }

            if (length !== undefined) { 
                localVarFormParams.append('Length', length as any);
            }

            if (name !== undefined) { 
                localVarFormParams.append('Name', name as any);
            }

            if (fileName !== undefined) { 
                localVarFormParams.append('FileName', fileName as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VesselTemplatesApi - functional programming interface
 */
export const VesselTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VesselTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the vessel template for the given vessel type kilns
         * @summary Returns the vessel template for the given vessel type kilns
         * @param {string} [vesselType] The vessel type for which a template should be downloaded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesseltemplatesDownload(vesselType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesseltemplatesDownload(vesselType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselTemplatesApi.getVesseltemplatesDownload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the all vessel type for which a template exists
         * @summary Returns the all vessel type for which a template exists
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesseltemplatesVesseltypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsAvailableVesselTemplateVesselTypesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesseltemplatesVesseltypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselTemplatesApi.getVesseltemplatesVesseltypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new vessel based on the provided excel template
         * @summary Create a new vessel based on the provided excel template
         * @param {string} customerId Identifier of the customer
         * @param {string} [contentType] 
         * @param {string} [contentDisposition] 
         * @param {object} [headers] 
         * @param {number} [length] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCustomerCustomeridVesseltemplatesUpload(customerId: string, contentType?: string, contentDisposition?: string, headers?: object, length?: number, name?: string, fileName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCustomerCustomeridVesseltemplatesUpload(customerId, contentType, contentDisposition, headers, length, name, fileName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselTemplatesApi.postCustomerCustomeridVesseltemplatesUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VesselTemplatesApi - factory interface
 */
export const VesselTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VesselTemplatesApiFp(configuration)
    return {
        /**
         * Returns the vessel template for the given vessel type kilns
         * @summary Returns the vessel template for the given vessel type kilns
         * @param {string} [vesselType] The vessel type for which a template should be downloaded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesseltemplatesDownload(vesselType?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getVesseltemplatesDownload(vesselType, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the all vessel type for which a template exists
         * @summary Returns the all vessel type for which a template exists
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesseltemplatesVesseltypes(options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV2ModelsAvailableVesselTemplateVesselTypesDto> {
            return localVarFp.getVesseltemplatesVesseltypes(options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new vessel based on the provided excel template
         * @summary Create a new vessel based on the provided excel template
         * @param {string} customerId Identifier of the customer
         * @param {string} [contentType] 
         * @param {string} [contentDisposition] 
         * @param {object} [headers] 
         * @param {number} [length] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCustomerCustomeridVesseltemplatesUpload(customerId: string, contentType?: string, contentDisposition?: string, headers?: object, length?: number, name?: string, fileName?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postCustomerCustomeridVesseltemplatesUpload(customerId, contentType, contentDisposition, headers, length, name, fileName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VesselTemplatesApi - object-oriented interface
 */
export class VesselTemplatesApi extends BaseAPI {
    /**
     * Returns the vessel template for the given vessel type kilns
     * @summary Returns the vessel template for the given vessel type kilns
     * @param {string} [vesselType] The vessel type for which a template should be downloaded
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesseltemplatesDownload(vesselType?: string, options?: RawAxiosRequestConfig) {
        return VesselTemplatesApiFp(this.configuration).getVesseltemplatesDownload(vesselType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the all vessel type for which a template exists
     * @summary Returns the all vessel type for which a template exists
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesseltemplatesVesseltypes(options?: RawAxiosRequestConfig) {
        return VesselTemplatesApiFp(this.configuration).getVesseltemplatesVesseltypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new vessel based on the provided excel template
     * @summary Create a new vessel based on the provided excel template
     * @param {string} customerId Identifier of the customer
     * @param {string} [contentType] 
     * @param {string} [contentDisposition] 
     * @param {object} [headers] 
     * @param {number} [length] 
     * @param {string} [name] 
     * @param {string} [fileName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postCustomerCustomeridVesseltemplatesUpload(customerId: string, contentType?: string, contentDisposition?: string, headers?: object, length?: number, name?: string, fileName?: string, options?: RawAxiosRequestConfig) {
        return VesselTemplatesApiFp(this.configuration).postCustomerCustomeridVesseltemplatesUpload(customerId, contentType, contentDisposition, headers, length, name, fileName, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VesselsApi - axios parameter creator
 */
export const VesselsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Sample request:                DELETE /vessels/00000000-0000-0000-0004-100000000000
         * @summary Delete a vessel by id
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVesselsVesselid: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('deleteVesselsVesselid', 'vesselId', vesselId)
            const localVarPath = `/Vessels/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels  GET /vessels?vesselType=0
         * @summary Retrieves all vessels
         * @param {string} [vesselType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVessels: async (vesselType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Vessels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vesselType !== undefined) {
                localVarQueryParameter['vesselType'] = vesselType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000
         * @summary Retrieves a vessel by id
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselid: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselid', 'vesselId', vesselId)
            const localVarPath = `/Vessels/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all vessel contact persons by vessel id
         * @summary Retrieves all vessel contact persons by vessel id
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidContactpersons: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidContactpersons', 'vesselId', vesselId)
            const localVarPath = `/Vessels/{vesselId}/contactpersons`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new vessel
         * @summary Create a new vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto] The json body which contains info about the new vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVessels: async (rHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Vessels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                PUT /vessels/00000000-0000-0000-0004-100000000000
         * @summary Updates a vessel by id
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto] The updated vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselid: async (vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselid', 'vesselId', vesselId)
            const localVarPath = `/Vessels/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update all vessel contact persons by vessel id
         * @summary Update all vessel contact persons by vessel id
         * @param {string} vesselId Identifier of the vessel
         * @param {Array<RHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto>} [rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto] A list of vessel contact persons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidContactpersons: async (vesselId: string, rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto?: Array<RHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidContactpersons', 'vesselId', vesselId)
            const localVarPath = `/Vessels/{vesselId}/contactpersons`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VesselsApi - functional programming interface
 */
export const VesselsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VesselsApiAxiosParamCreator(configuration)
    return {
        /**
         * Sample request:                DELETE /vessels/00000000-0000-0000-0004-100000000000
         * @summary Delete a vessel by id
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVesselsVesselid(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVesselsVesselid(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselsApi.deleteVesselsVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels  GET /vessels?vesselType=0
         * @summary Retrieves all vessels
         * @param {string} [vesselType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVessels(vesselType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMHMDCustomerManagementContractsV2CustomerVesselDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVessels(vesselType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselsApi.getVessels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000
         * @summary Retrieves a vessel by id
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselid(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMHMDCustomerManagementContractsV2CustomerVesselDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselid(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselsApi.getVesselsVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all vessel contact persons by vessel id
         * @summary Retrieves all vessel contact persons by vessel id
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidContactpersons(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOCustomerManagementWebV2ModelsContactPersonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidContactpersons(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselsApi.getVesselsVesselidContactpersons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new vessel
         * @summary Create a new vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto] The json body which contains info about the new vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postVessels(rHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMHMDCustomerManagementContractsV2CustomerVesselDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postVessels(rHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselsApi.postVessels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                PUT /vessels/00000000-0000-0000-0004-100000000000
         * @summary Updates a vessel by id
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto] The updated vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselid(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselid(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselsApi.putVesselsVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update all vessel contact persons by vessel id
         * @summary Update all vessel contact persons by vessel id
         * @param {string} vesselId Identifier of the vessel
         * @param {Array<RHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto>} [rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto] A list of vessel contact persons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidContactpersons(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto?: Array<RHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidContactpersons(vesselId, rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselsApi.putVesselsVesselidContactpersons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VesselsApi - factory interface
 */
export const VesselsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VesselsApiFp(configuration)
    return {
        /**
         * Sample request:                DELETE /vessels/00000000-0000-0000-0004-100000000000
         * @summary Delete a vessel by id
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVesselsVesselid(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteVesselsVesselid(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels  GET /vessels?vesselType=0
         * @summary Retrieves all vessels
         * @param {string} [vesselType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVessels(vesselType?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMHMDCustomerManagementContractsV2CustomerVesselDto>> {
            return localVarFp.getVessels(vesselType, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000
         * @summary Retrieves a vessel by id
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselid(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMHMDCustomerManagementContractsV2CustomerVesselDto> {
            return localVarFp.getVesselsVesselid(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all vessel contact persons by vessel id
         * @summary Retrieves all vessel contact persons by vessel id
         * @param {string} vesselId Identifier of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidContactpersons(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOCustomerManagementWebV2ModelsContactPersonDto>> {
            return localVarFp.getVesselsVesselidContactpersons(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new vessel
         * @summary Create a new vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto] The json body which contains info about the new vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVessels(rHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMHMDCustomerManagementContractsV2CustomerVesselDto> {
            return localVarFp.postVessels(rHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                PUT /vessels/00000000-0000-0000-0004-100000000000
         * @summary Updates a vessel by id
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto] The updated vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselid(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselid(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update all vessel contact persons by vessel id
         * @summary Update all vessel contact persons by vessel id
         * @param {string} vesselId Identifier of the vessel
         * @param {Array<RHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto>} [rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto] A list of vessel contact persons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidContactpersons(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto?: Array<RHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselsVesselidContactpersons(vesselId, rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VesselsApi - object-oriented interface
 */
export class VesselsApi extends BaseAPI {
    /**
     * Sample request:                DELETE /vessels/00000000-0000-0000-0004-100000000000
     * @summary Delete a vessel by id
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteVesselsVesselid(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselsApiFp(this.configuration).deleteVesselsVesselid(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels  GET /vessels?vesselType=0
     * @summary Retrieves all vessels
     * @param {string} [vesselType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVessels(vesselType?: string, options?: RawAxiosRequestConfig) {
        return VesselsApiFp(this.configuration).getVessels(vesselType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                GET /vessels/00000000-0000-0000-0004-100000000000
     * @summary Retrieves a vessel by id
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselid(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselsApiFp(this.configuration).getVesselsVesselid(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all vessel contact persons by vessel id
     * @summary Retrieves all vessel contact persons by vessel id
     * @param {string} vesselId Identifier of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidContactpersons(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselsApiFp(this.configuration).getVesselsVesselidContactpersons(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new vessel
     * @summary Create a new vessel
     * @param {RHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto] The json body which contains info about the new vessel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postVessels(rHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto, options?: RawAxiosRequestConfig) {
        return VesselsApiFp(this.configuration).postVessels(rHIMAPOCustomerManagementWebV2ModelsVesselCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                PUT /vessels/00000000-0000-0000-0004-100000000000
     * @summary Updates a vessel by id
     * @param {string} vesselId Identifier of the vessel
     * @param {RHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto} [rHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto] The updated vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselid(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto?: RHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return VesselsApiFp(this.configuration).putVesselsVesselid(vesselId, rHIMAPOCustomerManagementWebV2ModelsVesselUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update all vessel contact persons by vessel id
     * @summary Update all vessel contact persons by vessel id
     * @param {string} vesselId Identifier of the vessel
     * @param {Array<RHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto>} [rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto] A list of vessel contact persons
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidContactpersons(vesselId: string, rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto?: Array<RHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto>, options?: RawAxiosRequestConfig) {
        return VesselsApiFp(this.configuration).putVesselsVesselidContactpersons(vesselId, rHIMAPOCustomerManagementWebV2ModelsUpdateContactPersonRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



